/**
 * 自定义二级菜单前缀
 */
export const SUBMENU_PREFIX = 'subMenu'

/**
 * 20251217-菜单改造新旧映射列表
 */
export const MENU_LIST = [
  {
    序号: 1,
    菜单路由: ' ',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2,
    菜单路由: ' ',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '销售产品',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '销售产品',
    '四级（新）': ' '
  },
  {
    序号: 3,
    菜单路由: '/portal/spms/sell-products-manage',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '销售产品',
    '3级菜单（旧）': '销售产品管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '销售产品',
    '四级（新）': '销售产品管理'
  },
  {
    序号: 4,
    菜单路由: '/portal/spms/examine-manage',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '销售产品',
    '3级菜单（旧）': '审核管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '销售产品',
    '四级（新）': '审核管理'
  },
  {
    序号: 5,
    菜单路由: '/portal/spms/product-channe-details',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '销售产品',
    '3级菜单（旧）': '产品渠道规则明细',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '销售产品',
    '四级（新）': '产品渠道规则明细'
  },
  {
    序号: 6,
    菜单路由: '/portal/spms/channel-allocation-calculation',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '销售产品',
    '3级菜单（旧）': '渠道分配试算',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '销售产品',
    '四级（新）': '渠道分配试算'
  },
  {
    序号: 7,
    菜单路由: '/portal/spms/channel-allocation-log',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '销售产品',
    '3级菜单（旧）': '渠道分配日志',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '销售产品',
    '四级（新）': '渠道分配日志'
  },
  {
    序号: 8,
    菜单路由: ' ',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '增值服务',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '增值服务',
    '四级（新）': ' '
  },
  {
    序号: 9,
    菜单路由: '/portal/spms/insure-basic-config',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '增值服务',
    '3级菜单（旧）': '保价基础配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '增值服务',
    '四级（新）': '保价基础配置'
  },
  {
    序号: 10,
    菜单路由: '/portal/spms/product-insure-config',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '增值服务',
    '3级菜单（旧）': '产品保价配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '增值服务',
    '四级（新）': '产品保价配置'
  },
  {
    序号: 11,
    菜单路由: '/portal/spms/insure-product-blacklist',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '增值服务',
    '3级菜单（旧）': '保价商品黑名单',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '增值服务',
    '四级（新）': '保价商品黑名单'
  },
  {
    序号: 12,
    菜单路由: '/portal/spms/overseas-redelivery-set',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '增值服务',
    '3级菜单（旧）': '海外重派设置',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '增值服务',
    '四级（新）': '海外重派设置'
  },
  {
    序号: 13,
    菜单路由: '/portal/spms/signature-service-config',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '增值服务',
    '3级菜单（旧）': '签名服务配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '增值服务',
    '四级（新）': '签名服务配置'
  },
  {
    序号: 14,
    菜单路由: ' ',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '服务渠道',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '服务渠道',
    '四级（新）': ' '
  },
  {
    序号: 15,
    菜单路由: '/portal/spms/service-channels-manage',
    '1级菜单（旧）': '产品管理',
    '2级菜单（旧）': '服务渠道',
    '3级菜单（旧）': '服务渠道管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品服务',
    '三级（新）': '服务渠道',
    '四级（新）': '服务渠道管理'
  },
  {
    序号: 2081,
    菜单路由: ' ',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2082,
    菜单路由: ' ',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '定价测算',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '定价测算',
    '四级（新）': ' '
  },
  {
    序号: 2083,
    菜单路由: '/portal/pds/calculate-plan',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '定价测算',
    '3级菜单（旧）': '测算方案列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '定价测算',
    '四级（新）': '测算方案列表'
  },
  {
    序号: 2084,
    菜单路由: '/portal/pds/calculate-record',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '定价测算',
    '3级菜单（旧）': '测算结果列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '定价测算',
    '四级（新）': '测算结果列表'
  },
  {
    序号: 2085,
    菜单路由: ' ',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '调价记录',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '调价记录',
    '四级（新）': ' '
  },
  {
    序号: 2086,
    菜单路由: '/portal/pds/price-adjust-plan',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '调价记录',
    '3级菜单（旧）': '调价计划列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '调价记录',
    '四级（新）': '调价计划列表'
  },
  {
    序号: 2087,
    菜单路由: '/portal/pds/price-adjust-sheet',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '调价记录',
    '3级菜单（旧）': '调价单列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '调价记录',
    '四级（新）': '调价单列表'
  },
  {
    序号: 2088,
    菜单路由: ' ',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '基础数据',
    '四级（新）': ' '
  },
  {
    序号: 2089,
    菜单路由: '/portal/pds/rate-import',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '汇率导入',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '基础数据',
    '四级（新）': '汇率导入'
  },
  {
    序号: 2090,
    菜单路由: '/portal/pds/rate-list',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '汇率查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '基础数据',
    '四级（新）': '汇率查询'
  },
  {
    序号: 2091,
    菜单路由: '/portal/pds/dest-port-import',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '测算数据导入',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '基础数据',
    '四级（新）': '测算数据导入'
  },
  {
    序号: 2092,
    菜单路由: '/portal/pds/dest-port-info',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '测算数据明细',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '基础数据',
    '四级（新）': '测算数据明细'
  },
  {
    序号: 2093,
    菜单路由: ' ',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '空运信息管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '空运信息管理',
    '四级（新）': ' '
  },
  {
    序号: 2094,
    菜单路由: '/portal/pds/predict-source',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '空运信息管理',
    '3级菜单（旧）': '空运预测资源',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '空运信息管理',
    '四级（新）': '空运预测资源'
  },
  {
    序号: 2095,
    菜单路由: '/portal/pds/resource-priority',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '空运信息管理',
    '3级菜单（旧）': '资源调配优先级',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '空运信息管理',
    '四级（新）': '资源调配优先级'
  },
  {
    序号: 2096,
    菜单路由: '/portal/pds/airline-manage',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '空运信息管理',
    '3级菜单（旧）': '纵队航线配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '空运信息管理',
    '四级（新）': '纵队航线配置'
  },
  {
    序号: 2097,
    菜单路由: ' ',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '订阅通知',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '订阅通知',
    '四级（新）': ' '
  },
  {
    序号: 2098,
    菜单路由: '/portal/pds/result-subscrib',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '订阅通知',
    '3级菜单（旧）': '订阅通知配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '订阅通知',
    '四级（新）': '订阅通知配置'
  },
  {
    序号: 2099,
    菜单路由: ' ',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '系统规则配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '系统规则配置',
    '四级（新）': ' '
  },
  {
    序号: 2100,
    菜单路由: '/portal/pds/test-product-config',
    '1级菜单（旧）': '产品定价',
    '2级菜单（旧）': '系统规则配置',
    '3级菜单（旧）': '测试产品配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '产品管理',
    '二级（新）': '产品定价',
    '三级（新）': '系统规则配置',
    '四级（新）': '测试产品配置'
  },
  {
    序号: 119,
    菜单路由: ' ',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 120,
    菜单路由: ' ',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '运单追踪',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '运单追踪',
    '四级（新）': ' '
  },
  {
    序号: 121,
    菜单路由: '/portal/tis/track-management/waybill-query-list',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '运单追踪',
    '3级菜单（旧）': '运单查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '运单追踪',
    '四级（新）': '运单查询'
  },
  {
    序号: 122,
    菜单路由: '/portal/wis/baisc-query/waybill-change-query',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '运单追踪',
    '3级菜单（旧）': '运单变更查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '运单追踪',
    '四级（新）': '运单变更查询'
  },
  {
    序号: 123,
    菜单路由: '/portal/tis/track-management/track-query-listDes',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '运单追踪',
    '3级菜单（旧）': '操作事件详情',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '运单追踪',
    '四级（新）': '操作事件详情'
  },
  {
    序号: 124,
    菜单路由: '/portal/tis/track-management/track-detail-query',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '运单追踪',
    '3级菜单（旧）': '操作明细查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '运单追踪',
    '四级（新）': '操作明细查询'
  },
  {
    序号: 125,
    菜单路由: '/portal/tis/track-management/track-archiving',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '运单追踪',
    '3级菜单（旧）': '归档轨迹查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '运单追踪',
    '四级（新）': '归档轨迹查询'
  },
  {
    序号: 126,
    菜单路由: '/portal/tis/track-management/track-repair-result',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '运单追踪',
    '3级菜单（旧）': '轨迹修复结果查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '运单追踪',
    '四级（新）': '轨迹修复结果查询'
  },
  {
    序号: 127,
    菜单路由: '/portal/tis/unmatcNode',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '运单追踪',
    '3级菜单（旧）': '未匹配节点查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '运单追踪',
    '四级（新）': '未匹配节点查询'
  },
  {
    序号: 128,
    菜单路由: '/portal/tis/system-log',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '运单追踪',
    '3级菜单（旧）': '轨迹日志追踪',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '运单追踪',
    '四级（新）': '轨迹日志追踪'
  },
  {
    序号: 129,
    菜单路由: ' ',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 130,
    菜单路由: '/portal/tis/facilitator',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': 'TIS服务商管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': 'TIS服务商管理'
  },
  {
    序号: 131,
    菜单路由: '/portal/tis/channel',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': 'TIS渠道管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': 'TIS渠道管理'
  },
  {
    序号: 132,
    菜单路由: '/portal/tis/channel-relation',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '装箱渠道与TIS渠道关联',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '服务渠道关联TIS渠道'
  },
  {
    序号: 133,
    菜单路由: '/portal/tis/tracking-node',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '轨迹节点管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '轨迹节点管理'
  },
  {
    序号: 134,
    菜单路由: '/portal/tis/track-business',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '轨迹业务阶段管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '轨迹业务阶段管理'
  },
  {
    序号: 135,
    菜单路由: '/portal/tis/track-management/add-track-approval',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '编辑轨迹审核',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '编辑轨迹审核'
  },
  {
    序号: 136,
    菜单路由: '/portal/tis/numbers-relation',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '轨迹单号关联',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '轨迹单号关联'
  },
  {
    序号: 137,
    菜单路由: '/portal/tis/aging-standard',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '标准时效配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '标准时效配置'
  },
  {
    序号: 138,
    菜单路由: '/portal/tis/track-management/track-subscription-management',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '轨迹订阅管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '轨迹订阅管理'
  },
  {
    序号: 139,
    菜单路由: '/portal/tis/node-deployment',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': 'TIS与LTS节点配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': 'TIS与LTS节点配置'
  },
  {
    序号: 140,
    菜单路由: '/portal/tis/track-config',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '轨迹策略配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '轨迹策略配置'
  },
  {
    序号: 141,
    菜单路由: '/portal/tis/track-notification',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '轨迹通知管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '轨迹通知管理'
  },
  {
    序号: 142,
    菜单路由: '/portal/tis/track-push-config',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '轨迹对外配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '轨迹对外配置'
  },
  {
    序号: 143,
    菜单路由: '/portal/tis/track-warning-config',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '轨迹监控配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '轨迹监控配置'
  },
  {
    序号: 144,
    菜单路由: '/portal/tis/manual-audit',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹配置',
    '3级菜单（旧）': '人工采纳审核',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹配置',
    '四级（新）': '人工采纳审核'
  },
  {
    序号: 145,
    菜单路由: ' ',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '运单配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '运单配置',
    '四级（新）': ' '
  },
  {
    序号: 146,
    菜单路由: '/portal/wis/baisc-config/waybill-diagnosis-config',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '运单配置',
    '3级菜单（旧）': '运单诊断配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '运单配置',
    '四级（新）': '运单诊断配置'
  },
  {
    序号: 147,
    菜单路由: ' ',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹报表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹监控',
    '四级（新）': ' '
  },
  {
    序号: 148,
    菜单路由: '/portal/tis/on-time-rate',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹报表',
    '3级菜单（旧）': '轨迹及时率报表',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹监控',
    '四级（新）': '轨迹及时率报表'
  },
  {
    序号: 149,
    菜单路由: '/portal/tis/track-push-monitoring',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹报表',
    '3级菜单（旧）': '轨迹推送监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹监控',
    '四级（新）': '轨迹推送监控'
  },
  {
    序号: 150,
    菜单路由: '/portal/tis/track-warning-details',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '轨迹报表',
    '3级菜单（旧）': '轨迹预警明细',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '全程轨迹管理',
    '三级（新）': '轨迹监控',
    '四级（新）': '轨迹预警明细'
  },
  {
    序号: 151,
    菜单路由: ' ',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '云颂轨迹管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '云颂轨迹管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 152,
    菜单路由: '/portal/fts/awb-track-list',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '云颂轨迹管理',
    '3级菜单（旧）': '云颂轨迹查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '云颂轨迹管理',
    '三级（新）': '云颂轨迹查询',
    '四级（新）': ' '
  },
  {
    序号: 153,
    菜单路由: '/portal/fts/flight-info-config',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '云颂轨迹管理',
    '3级菜单（旧）': '航班信息配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '云颂轨迹管理',
    '三级（新）': '航班信息配置',
    '四级（新）': ' '
  },
  {
    序号: 154,
    菜单路由: '/portal/fts/track-forecast',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '云颂轨迹管理',
    '3级菜单（旧）': '轨迹预报配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '云颂轨迹管理',
    '三级（新）': '轨迹预报配置',
    '四级（新）': ' '
  },
  {
    序号: 155,
    菜单路由: '/portal/fts/track-reception',
    '1级菜单（旧）': '轨迹管理',
    '2级菜单（旧）': '云颂轨迹管理',
    '3级菜单（旧）': '轨迹接收配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '轨迹管理',
    '二级（新）': '云颂轨迹管理',
    '三级（新）': '轨迹接收配置',
    '四级（新）': ' '
  },
  {
    序号: 366,
    菜单路由: ' ',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 367,
    菜单路由: ' ',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '工作台',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '工作台',
    '四级（新）': ' '
  },
  {
    序号: 368,
    菜单路由: '/portal/wos/my-work-order',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '工作台',
    '3级菜单（旧）': '我的工单',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '工作台',
    '四级（新）': '我的工单'
  },
  {
    序号: 369,
    菜单路由: '/portal/wos/workbench/question-piece',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '工作台',
    '3级菜单（旧）': '库内问题件',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '工作台',
    '四级（新）': '库内问题件'
  },
  {
    序号: 370,
    菜单路由: '/portal/wos/workbench/oversea-piece',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '工作台',
    '3级菜单（旧）': '尾程问题件',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '工作台',
    '四级（新）': '尾程问题件'
  },
  {
    序号: 371,
    菜单路由: '/portal/wos/my-mission-list',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '工作台',
    '3级菜单（旧）': '咨询/查件/投诉',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '工作台',
    '四级（新）': '咨询/查件/投诉'
  },
  {
    序号: 372,
    菜单路由: '/portal/wos/workbench/other-piece',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '工作台',
    '3级菜单（旧）': '其他协同工单',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '工作台',
    '四级（新）': '其他协同工单'
  },
  {
    序号: 373,
    菜单路由: '/portal/wos/abnormalPushStatistics',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '工作台',
    '3级菜单（旧）': '异常订单统计推送',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '工作台',
    '四级（新）': '异常订单统计推送'
  },
  {
    序号: 374,
    菜单路由: '/portal/wos/workbench/b2b-big-order',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '工作台',
    '3级菜单（旧）': 'B2B大货工单',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '工作台',
    '四级（新）': 'B2B大货工单'
  },
  {
    序号: 375,
    菜单路由: '/portal/wos/basic-data',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '基础数据维护',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '基础数据维护',
    '四级（新）': ' '
  },
  {
    序号: 376,
    菜单路由: '/portal/wos/import-result',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '导入结果查询',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '导入结果查询',
    '四级（新）': ' '
  },
  {
    序号: 377,
    菜单路由: '/portal/wos/work-type',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '工单类型维护',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '工单类型维护',
    '四级（新）': ' '
  },
  {
    序号: 378,
    菜单路由: '/portal/wos/abnormal-bill',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '异常提单查询',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '异常提单查询',
    '四级（新）': ' '
  },
  {
    序号: 379,
    菜单路由: '/portal/wos/return-redispatch-channel',
    '1级菜单（旧）': '协同工单',
    '2级菜单（旧）': '退件重派渠道',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '协同工单',
    '三级（新）': '退件重派渠道',
    '四级（新）': ' '
  },
  {
    序号: 380,
    菜单路由: ' ',
    '1级菜单（旧）': '小云工单',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '小云工单',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 381,
    菜单路由: '/portal/business/owos-xiaoyun/workorder',
    '1级菜单（旧）': '小云工单',
    '2级菜单（旧）': '小云工单列表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '小云工单',
    '三级（新）': '小云工单列表',
    '四级（新）': ' '
  },
  {
    序号: 382,
    菜单路由: '/portal/business/owos-xiaoyun/form-type',
    '1级菜单（旧）': '小云工单',
    '2级菜单（旧）': '小云工单类型',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '小云工单',
    '三级（新）': '小云工单类型',
    '四级（新）': ' '
  },
  {
    序号: 383,
    菜单路由: '/portal/business/owos-xiaoyun/form-template',
    '1级菜单（旧）': '小云工单',
    '2级菜单（旧）': '小云工单表单模板库',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '小云工单',
    '三级（新）': '小云工单表单模板库',
    '四级（新）': ' '
  },
  {
    序号: 384,
    菜单路由: '/portal/business/owos-xiaoyun/route',
    '1级菜单（旧）': '小云工单',
    '2级菜单（旧）': '小云工单路由规则',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '小云工单',
    '三级（新）': '小云工单路由规则',
    '四级（新）': ' '
  },
  {
    序号: 385,
    菜单路由: '/portal/business/owos-xiaoyun/staffs',
    '1级菜单（旧）': '小云工单',
    '2级菜单（旧）': '小云工单成员管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '小云工单',
    '三级（新）': '小云工单成员管理',
    '四级（新）': ' '
  },
  {
    序号: 386,
    菜单路由: '/portal/business/owos-xiaoyun/notice',
    '1级菜单（旧）': '小云工单',
    '2级菜单（旧）': '小云工单公告',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '小云工单',
    '三级（新）': '小云工单公告',
    '四级（新）': ' '
  },
  {
    序号: 387,
    菜单路由: '/portal/business/owos-xiaoyun/bugList',
    '1级菜单（旧）': '小云工单',
    '2级菜单（旧）': '小云工单缺陷列表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '小云工单',
    '三级（新）': '小云工单缺陷列表',
    '四级（新）': ' '
  },
  {
    序号: 388,
    菜单路由: ' ',
    '1级菜单（旧）': '小云工单',
    '2级菜单（旧）': '小云工单统计信息',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '小云工单',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 389,
    菜单路由: '/portal/business/owos-xiaoyun/report',
    '1级菜单（旧）': '小云工单',
    '2级菜单（旧）': '小云工单统计信息',
    '3级菜单（旧）': '工单统计信息',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '小云工单',
    '三级（新）': '小云工单统计信息',
    '四级（新）': ' '
  },
  {
    序号: 390,
    菜单路由: '/portal/business/owos-xiaoyun/statistics',
    '1级菜单（旧）': '小云工单',
    '2级菜单（旧）': '小云工单统计信息',
    '3级菜单（旧）': '工单详情信息',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '小云工单',
    '三级（新）': '小云工单详情信息',
    '四级（新）': ' '
  },
  {
    序号: 391,
    菜单路由: ' ',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 392,
    菜单路由: ' ',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '客服工单',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '客服工单',
    '四级（新）': ' '
  },
  {
    序号: 393,
    菜单路由: '/portal/icms/work-order-management/create-work-order',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '客服工单',
    '3级菜单（旧）': '创建工单',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '客服工单',
    '四级（新）': '创建工单'
  },
  {
    序号: 394,
    菜单路由: ' ',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '客服工单',
    '3级菜单（旧）': '工单列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '客服工单',
    '四级（新）': ' '
  },
  {
    序号: 395,
    菜单路由: '/portal/icms/work-order-management/my-mission-list',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '客服工单',
    '3级菜单（旧）': '工单列表',
    '4级菜单（旧）': '咨询/查件/投诉',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '客服工单',
    '四级（新）': '咨询/查件/投诉'
  },
  {
    序号: 396,
    菜单路由: '/portal/icms/workbench/my-work-order',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '客服工单',
    '3级菜单（旧）': '工单列表',
    '4级菜单（旧）': '我的工单',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '客服工单',
    '四级（新）': '我的工单'
  },
  {
    序号: 397,
    菜单路由: '/portal/icms/work-order-management/export-order-list',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '客服工单',
    '3级菜单（旧）': '导入结果查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '客服工单',
    '四级（新）': '导入结果查询'
  },
  {
    序号: 398,
    菜单路由: '/portal/icms/work-order-management/basic-data-list',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '客服工单',
    '3级菜单（旧）': '基础数据维护',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '客服工单',
    '四级（新）': '基础数据维护'
  },
  {
    序号: 399,
    菜单路由: '/portal/icms/work-order-management/template-settings',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '客服工单',
    '3级菜单（旧）': '模板设置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '客服工单',
    '四级（新）': '模板设置'
  },
  {
    序号: 400,
    菜单路由: '/portal/icms/work-order-management/process-management-list',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '客服工单',
    '3级菜单（旧）': '流程管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '客服工单',
    '四级（新）': '流程管理'
  },
  {
    序号: 401,
    菜单路由: ' ',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '数据报表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '数据报表',
    '四级（新）': ' '
  },
  {
    序号: 402,
    菜单路由: '/portal/icms/data-report/status-flow',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '数据报表',
    '3级菜单（旧）': '状态流转表',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '数据报表',
    '四级（新）': '状态流转表'
  },
  {
    序号: 403,
    菜单路由: '/portal/icms/data-report/source-statistics',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '数据报表',
    '3级菜单（旧）': '来源统计表',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '数据报表',
    '四级（新）': '来源统计表'
  },
  {
    序号: 404,
    菜单路由: '/portal/icms/data-report/work-order-reply',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '数据报表',
    '3级菜单（旧）': '工单回复统计表',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '数据报表',
    '四级（新）': '工单回复统计表'
  },
  {
    序号: 405,
    菜单路由: '/portal/icms/data-report/work-order-timeliness',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '数据报表',
    '3级菜单（旧）': '工单时效报表',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '数据报表',
    '四级（新）': '工单时效报表'
  },
  {
    序号: 406,
    菜单路由: ' ',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '公共配置管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '公共配置管理',
    '四级（新）': ' '
  },
  {
    序号: 407,
    菜单路由: '/portal/icms/public-config-management/work-order-process-config',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '公共配置管理',
    '3级菜单（旧）': '工单流程配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '公共配置管理',
    '四级（新）': '工单流程配置'
  },
  {
    序号: 408,
    菜单路由: '/portal/icms/public-config-management/work-order-basic-config',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '公共配置管理',
    '3级菜单（旧）': '工单通用基础配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '公共配置管理',
    '四级（新）': '工单通用基础配置'
  },
  {
    序号: 409,
    菜单路由: '/portal/icms/public-config-management/basic-data-list',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '公共配置管理',
    '3级菜单（旧）': '完结原因',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '公共配置管理',
    '四级（新）': '完结原因'
  },
  {
    序号: 410,
    菜单路由: '/portal/icms/public-config-management/check-rules-setting',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '公共配置管理',
    '3级菜单（旧）': '开查规则配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '公共配置管理',
    '四级（新）': '开查规则配置'
  },
  {
    序号: 411,
    菜单路由: ' ',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '质控异常工单',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '质控异常工单',
    '四级（新）': ' '
  },
  {
    序号: 412,
    菜单路由: '/portal/icms/quality-exception-transport-order',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '质控异常工单',
    '3级菜单（旧）': '质控异常运单',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '质控异常工单',
    '四级（新）': '质控异常运单'
  },
  {
    序号: 413,
    菜单路由: '/portal/icms/feishu-notice-bill',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '质控异常工单',
    '3级菜单（旧）': '飞书通知台账',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '质控异常工单',
    '四级（新）': '飞书通知台账'
  },
  {
    序号: 414,
    菜单路由: '/portal/icms/custom-level-setting',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '质控异常工单',
    '3级菜单（旧）': '客户层级配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '质控异常工单',
    '四级（新）': '客户层级配置'
  },
  {
    序号: 415,
    菜单路由: '/portal/icms/custom-language-skill',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '质控异常工单',
    '3级菜单（旧）': '客服话术配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '质控异常工单',
    '四级（新）': '客服话术配置'
  },
  {
    序号: 416,
    菜单路由: '/portal/icms/quality-except-order-audit',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '质控异常工单',
    '3级菜单（旧）': '质控异常订单审核',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': '质控异常工单',
    '四级（新）': '质控异常订单审核'
  },
  {
    序号: 417,
    菜单路由: ' ',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 418,
    菜单路由: ' ',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '基础数据',
    '四级（新）': ' '
  },
  {
    序号: 419,
    菜单路由: '/portal/css/basic-data/claims-reason-setting',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '配置赔偿原因',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '基础数据',
    '四级（新）': '配置赔偿原因'
  },
  {
    序号: 420,
    菜单路由: '/portal/css/basic-data/area-department-setting',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '配置大区及责任部门',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '基础数据',
    '四级（新）': '配置大区及责任部门'
  },
  {
    序号: 421,
    菜单路由: '/portal/css/basic-data/claims-type-setting',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '配置赔偿类型',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '基础数据',
    '四级（新）': '配置赔偿类型'
  },
  {
    序号: 422,
    菜单路由: '/portal/css/basic-data/link-setting',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '配置环节',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '基础数据',
    '四级（新）': '配置环节'
  },
  {
    序号: 423,
    菜单路由: '/portal/css/basic-data/break-claims-rule',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '断更理赔规则',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '基础数据',
    '四级（新）': '断更理赔规则'
  },
  {
    序号: 424,
    菜单路由: '/portal/css/basic-data/auto-claims-rule',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '自动拒赔规则',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '基础数据',
    '四级（新）': '自动拒赔规则'
  },
  {
    序号: 425,
    菜单路由: '/portal/css/basic-data/auto-create-rule',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '自动建标赔规则',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '基础数据',
    '四级（新）': '自动建标赔规则'
  },
  {
    序号: 426,
    菜单路由: '/portal/css/basic-data/auto-audit-rule',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '自动审核规则',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '基础数据',
    '四级（新）': '自动审核规则'
  },
  {
    序号: 427,
    菜单路由: ' ',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '理赔单维护',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '理赔单维护',
    '四级（新）': ' '
  },
  {
    序号: 428,
    菜单路由: '/portal/css/claims-setting/customer-claims-application',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '理赔单维护',
    '3级菜单（旧）': '客户申请理赔',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '理赔单维护',
    '四级（新）': '客户申请理赔'
  },
  {
    序号: 429,
    菜单路由: '/portal/css/claims-setting/pre-claims',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '理赔单维护',
    '3级菜单（旧）': '预理赔单列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '理赔单维护',
    '四级（新）': '预理赔单列表'
  },
  {
    序号: 430,
    菜单路由: '/portal/css/claims-setting/standard-claims',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '理赔单维护',
    '3级菜单（旧）': '标准理赔列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '理赔单维护',
    '四级（新）': '标准理赔列表'
  },
  {
    序号: 431,
    菜单路由: '/portal/css/claims-setting/special-claims',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '理赔单维护',
    '3级菜单（旧）': '特殊理赔列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '理赔单维护',
    '四级（新）': '特殊理赔列表'
  },
  {
    序号: 432,
    菜单路由: '/portal/css/claims-setting/customer-claims',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '理赔单维护',
    '3级菜单（旧）': '平台客户理赔列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '理赔单维护',
    '四级（新）': '平台客户理赔列表'
  },
  {
    序号: 433,
    菜单路由: ' ',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '导推记录',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 434,
    菜单路由: '/portal/css/record-import/claims-batch-import',
    '1级菜单（旧）': '理赔管理',
    '2级菜单（旧）': '导推记录',
    '3级菜单（旧）': '批量理赔单导入',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户理赔',
    '三级（新）': '理赔单维护',
    '四级（新）': '批量理赔单导入'
  },
  {
    序号: 664,
    菜单路由: ' ',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 665,
    菜单路由: ' ',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '配置管理',
    '四级（新）': ' '
  },
  {
    序号: 666,
    菜单路由: '/portal/yt-portal-itcs/basic-config/process-mode',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '任务类型配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '配置管理',
    '四级（新）': '任务类型配置'
  },
  {
    序号: 667,
    菜单路由: '/portal/yt-portal-itcs/basic-config/carrier-investigation',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '服务商开查方式配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '配置管理',
    '四级（新）': '服务商开查方式配置'
  },
  {
    序号: 668,
    菜单路由: ' ',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '导推记录',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 669,
    菜单路由: '/portal/yt-portal-itcs/import-record',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '导推记录',
    '3级菜单（旧）': '导入记录查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '任务管理 ',
    '四级（新）': '导入记录查询'
  },
  {
    序号: 670,
    菜单路由: ' ',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '任务管理 ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '任务管理 ',
    '四级（新）': ' '
  },
  {
    序号: 671,
    菜单路由: '/portal/yt-portal-itcs/pod-download',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '任务管理 ',
    '3级菜单（旧）': 'POD下载任务',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '任务管理 ',
    '四级（新）': 'POD下载任务'
  },
  {
    序号: 672,
    菜单路由: '/portal/yt-portal-itcs/sea-investigation',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '任务管理 ',
    '3级菜单（旧）': '海外开查任务',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '任务管理 ',
    '四级（新）': '海外开查任务'
  },
  {
    序号: 673,
    菜单路由: '/portal/yt-portal-itcs/email-receive-record',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '任务管理 ',
    '3级菜单（旧）': '邮件接收记录',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '任务管理 ',
    '四级（新）': '邮件接收记录'
  },
  {
    序号: 674,
    菜单路由: ' ',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '规则配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '配置管理',
    '四级（新）': ' '
  },
  {
    序号: 675,
    菜单路由: '/portal/yt-portal-itcs/investigation-rule',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '规则配置',
    '3级菜单（旧）': '开查规则配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '配置管理',
    '四级（新）': '开查规则配置'
  },
  {
    序号: 676,
    菜单路由: '/portal/yt-portal-itcs/parse-rule',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '规则配置',
    '3级菜单（旧）': '解析规则配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '配置管理',
    '四级（新）': '解析规则配置'
  },
  {
    序号: 2116,
    菜单路由: '/portal/icms/public-config-management/judge-rules-setting',
    '1级菜单（旧）': '客户工单',
    '2级菜单（旧）': '公共配置管理',
    '3级菜单（旧）': '判责依据配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '客户工单',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2157,
    菜单路由: '/portal/yt-portal-itcs/push-record',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '导推记录',
    '3级菜单（旧）': '数据推送记录',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '导推记录',
    '四级（新）': '数据推送记录'
  },
  {
    序号: 2158,
    菜单路由: '/portal/yt-portal-itcs/rpa-record',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '任务管理 ',
    '3级菜单（旧）': 'RPA执行记录',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '任务管理 ',
    '四级（新）': 'RPA执行记录'
  },
  {
    序号: 2159,
    菜单路由: '/portal/yt-portal-itcs/claim-investigation',
    '1级菜单（旧）': '智能工具配置',
    '2级菜单（旧）': '任务管理 ',
    '3级菜单（旧）': '索赔开查任务',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': '智能工具',
    '三级（新）': '任务管理 ',
    '四级（新）': '索赔开查任务'
  },
  {
    序号: 2160,
    菜单路由: ' ',
    '1级菜单（旧）': 'AI服务平台',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': 'AI智能质检',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2161,
    菜单路由: ' ',
    '1级菜单（旧）': 'AI服务平台',
    '2级菜单（旧）': '智能质检',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': 'AI智能质检',
    '三级（新）': '智能质检',
    '四级（新）': ' '
  },
  {
    序号: 2162,
    菜单路由: '/portal/aisp/quality-inspection/rule',
    '1级菜单（旧）': 'AI服务平台',
    '2级菜单（旧）': '智能质检',
    '3级菜单（旧）': '质检规则配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': 'AI智能质检',
    '三级（新）': '智能质检',
    '四级（新）': '质检规则配置'
  },
  {
    序号: 2163,
    菜单路由: '/portal/aisp/quality-inspection/result',
    '1级菜单（旧）': 'AI服务平台',
    '2级菜单（旧）': '智能质检',
    '3级菜单（旧）': '质检结果',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': 'AI智能质检',
    '三级（新）': '智能质检',
    '四级（新）': '质检结果'
  },
  {
    序号: 2164,
    菜单路由: '/portal/aisp/quality-inspection/report',
    '1级菜单（旧）': 'AI服务平台',
    '2级菜单（旧）': '智能质检',
    '3级菜单（旧）': '质检报表',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': 'AI智能质检',
    '三级（新）': '智能质检',
    '四级（新）': '质检报表'
  },
  {
    序号: 2165,
    菜单路由: '/portal/aisp/quality-inspection/dashboard',
    '1级菜单（旧）': 'AI服务平台',
    '2级菜单（旧）': '智能质检',
    '3级菜单（旧）': '质检统计看板',
    '4级菜单（旧）': ' ',
    '一级（新）': '客户服务',
    '二级（新）': 'AI智能质检',
    '三级（新）': '智能质检',
    '四级（新）': '质检统计看板'
  },
  {
    序号: 16,
    菜单路由: ' ',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 17,
    菜单路由: ' ',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '全段订单',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单查询',
    '四级（新）': ' '
  },
  {
    序号: 18,
    菜单路由: '/portal/oms/order-list',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '全段订单',
    '3级菜单（旧）': '网上订单管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单查询',
    '四级（新）': '网上订单管理'
  },
  {
    序号: 19,
    菜单路由: '/portal/oms/forecast-order',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '全段订单',
    '3级菜单（旧）': '预报订单管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单查询',
    '四级（新）': '预报订单管理'
  },
  {
    序号: 20,
    菜单路由: '/portal/oms/forecast-fail',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '全段订单',
    '3级菜单（旧）': '预报失败转渠道',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单查询',
    '四级（新）': '预报失败转渠道'
  },
  {
    序号: 21,
    菜单路由: '/portal/oms/download-center',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '全段订单',
    '3级菜单（旧）': '下载中心',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单查询',
    '四级（新）': '下载中心'
  },
  {
    序号: 22,
    菜单路由: '/portal/oms/log-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '全段订单',
    '3级菜单（旧）': '日志查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单查询',
    '四级（新）': '日志查询'
  },
  {
    序号: 23,
    菜单路由: '/portal/oms/big-bag',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '全段订单',
    '3级菜单（旧）': '大包到货监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单监控',
    '四级（新）': '大包到货监控'
  },
  {
    序号: 24,
    菜单路由: '/portal/oms/repeat-forecast',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '全段订单',
    '3级菜单（旧）': '重复预报监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单监控',
    '四级（新）': '重复预报监控'
  },
  {
    序号: 25,
    菜单路由: '/portal/oms/pre-access',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '全段订单',
    '3级菜单（旧）': '预上网数据监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单监控',
    '四级（新）': '预上网数据监控'
  },
  {
    序号: 26,
    菜单路由: '/portal/oms/check-order',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '全段订单',
    '3级菜单（旧）': '跟踪号查订单',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单查询',
    '四级（新）': '跟踪号查订单'
  },
  {
    序号: 27,
    菜单路由: ' ',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单查询',
    '四级（新）': ' '
  },
  {
    序号: 28,
    菜单路由: '/portal/oms/stage-order/end-sort-order',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '小包订单',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单查询',
    '四级（新）': '小包订单'
  },
  {
    序号: 29,
    菜单路由: '/portal/oms/stage-order/batch-list',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '批次列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单查询',
    '四级（新）': '批次列表'
  },
  {
    序号: 30,
    菜单路由: '/portal/oms/stage-order/bill-lading',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '清关订单',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单查询',
    '四级（新）': '清关订单'
  },
  {
    序号: 31,
    菜单路由: '/portal/oms/stage-order/delivery-list',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '总包预报列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单查询',
    '四级（新）': '总包预报列表'
  },
  {
    序号: 32,
    菜单路由: '/portal/oms/stage-order/customer-box-list',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '客户箱子列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单查询',
    '四级（新）': '客户箱子列表'
  },
  {
    序号: 33,
    菜单路由: '/portal/oms/stage-order/transfer-order',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '中转订单',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单查询',
    '四级（新）': '中转订单'
  },
  {
    序号: 34,
    菜单路由: '/portal/oms/stage-order/product-line-config',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '产品线配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单配置',
    '四级（新）': '产品线配置'
  },
  {
    序号: 35,
    菜单路由: '/portal/oms/stage-order/port-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '港口管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单配置',
    '四级（新）': '港口管理'
  },
  {
    序号: 36,
    菜单路由: '/portal/oms/stage-order/clearance-template',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '清关模板',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单配置',
    '四级（新）': '清关模板'
  },
  {
    序号: 37,
    菜单路由: '/portal/oms/stage-order/customer-config',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '客户配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单配置',
    '四级（新）': '客户配置'
  },
  {
    序号: 38,
    菜单路由: ' ',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': 'B2B订单',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': 'B2B订单管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 39,
    菜单路由: '/portal/oms/B2B-order/B2B-order-list',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': 'B2B订单',
    '3级菜单（旧）': 'B2B订单列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': 'B2B订单管理',
    '三级（新）': 'B2B订单列表',
    '四级（新）': ' '
  },
  {
    序号: 40,
    菜单路由: '/portal/oms/B2B-order/B2B-forecast-order',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': 'B2B订单',
    '3级菜单（旧）': 'B2B预报订单列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': 'B2B订单管理',
    '三级（新）': 'B2B预报订单列表',
    '四级（新）': ' '
  },
  {
    序号: 41,
    菜单路由: ' ',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': ' '
  },
  {
    序号: 42,
    菜单路由: '/portal/oms/data-push',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '数据推送管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段技术配置',
    '四级（新）': '数据推送管理'
  },
  {
    序号: 43,
    菜单路由: '/portal/oms/system-secret-key',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '系统密钥配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段技术配置',
    '四级（新）': '系统密钥配置'
  },
  {
    序号: 44,
    菜单路由: '/portal/oms/dictionary-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '字典管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段技术配置',
    '四级（新）': '字典管理'
  },
  {
    序号: 45,
    菜单路由: '/portal/oms/frm-config',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '业务流程配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': '业务流程配置'
  },
  {
    序号: 46,
    菜单路由: '/portal/oms/ioss-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': 'IOSS税号管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': 'IOSS税号管理'
  },
  {
    序号: 47,
    菜单路由: '/portal/oms/yuntu-ioss',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '云途IOSS号管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': '云途IOSS号管理'
  },
  {
    序号: 48,
    菜单路由: '/portal/oms/internal-ioss-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '内部IOSS号管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': '内部IOSS号管理'
  },
  {
    序号: 49,
    菜单路由: '/portal/oms/vat-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': 'VAT税号管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': 'VAT税号管理'
  },
  {
    序号: 50,
    菜单路由: '/portal/oms/addvalue-tax-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '增值税号管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': '增值税号管理'
  },
  {
    序号: 51,
    菜单路由: '/portal/oms/sku-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': 'SKU管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': 'SKU管理'
  },
  {
    序号: 52,
    菜单路由: '/portal/oms/sensitive-word-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '敏感词管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': '敏感词管理'
  },
  {
    序号: 53,
    菜单路由: '/portal/oms/warehouse-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': 'FBA仓库地址管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': 'FBA仓库地址管理'
  },
  {
    序号: 54,
    菜单路由: '/portal/oms/push-failed',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '推送失败管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段技术配置',
    '四级（新）': '推送失败管理'
  },
  {
    序号: 55,
    菜单路由: '/portal/oms/amazon-address',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '亚马逊地址限制管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': '亚马逊地址限制管理'
  },
  {
    序号: 56,
    菜单路由: '/portal/oms/virtual-services',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '虚拟服务商',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': '虚拟服务商'
  },
  {
    序号: 57,
    菜单路由: '/portal/oms/tracking-mapping',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '轨迹节点配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': '轨迹节点配置'
  },
  {
    序号: 58,
    菜单路由: '/portal/oms/cancel-forecast',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': '批量取消预报',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单查询',
    '四级（新）': '批量取消预报'
  },
  {
    序号: 59,
    菜单路由: '/portal/oms/cirro-order-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '基础配置',
    '3级菜单（旧）': 'CIRRO单号池管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': 'CIRRO单号池管理'
  },
  {
    序号: 60,
    菜单路由: ' ',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '信控管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '信控管理',
    '四级（新）': ' '
  },
  {
    序号: 61,
    菜单路由: '/portal/oms/order-control',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '信控管理',
    '3级菜单（旧）': '客户下单管控',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '信控管理',
    '四级（新）': '客户下单管控'
  },
  {
    序号: 62,
    菜单路由: '/portal/oms/revenue',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '信控管理',
    '3级菜单（旧）': '收入和货量预警',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '信控管理',
    '四级（新）': '收入和货量预警'
  },
  {
    序号: 63,
    菜单路由: '/portal/oms/customer-rps',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '信控管理',
    '3级菜单（旧）': '客户RPS调控',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '信控管理',
    '四级（新）': '客户RPS调控'
  },
  {
    序号: 64,
    菜单路由: '/portal/oms/can-order-num',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '信控管理',
    '3级菜单（旧）': '客户可下单数',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '信控管理',
    '四级（新）': '客户可下单数'
  },
  {
    序号: 65,
    菜单路由: '/portal/oms/control-list',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '信控管理',
    '3级菜单（旧）': '信控订单列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '信控管理',
    '四级（新）': '信控订单列表'
  },
  {
    序号: 66,
    菜单路由: '/portal/oms/intercept-list',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '信控管理',
    '3级菜单（旧）': '拦截数列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '信控管理',
    '四级（新）': '拦截数列表'
  },
  {
    序号: 67,
    菜单路由: ' ',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '订单配置管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': ' '
  },
  {
    序号: 68,
    菜单路由: '/portal/oms/order-limit-config',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '订单配置管理',
    '3级菜单（旧）': '客户下单限量配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段业务配置',
    '四级（新）': '客户下单限量配置'
  },
  {
    序号: 69,
    菜单路由: ' ',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '订单任务',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单查询',
    '四级（新）': ' '
  },
  {
    序号: 70,
    菜单路由: '/portal/oms/overseas-exchange-task',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '订单任务',
    '3级菜单（旧）': '海外换单任务',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '全段订单管理',
    '三级（新）': '全段订单查询',
    '四级（新）': '海外换单任务'
  },
  {
    序号: 71,
    菜单路由: ' ',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 72,
    菜单路由: ' ',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '平台订单管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台订单查询',
    '四级（新）': ' '
  },
  {
    序号: 73,
    菜单路由: '/portal/poms/platform-order-list',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '平台订单管理',
    '3级菜单（旧）': '平台订单列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台订单查询',
    '四级（新）': '平台订单列表'
  },
  {
    序号: 74,
    菜单路由: '/portal/poms/pre-order',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '平台订单管理',
    '3级菜单（旧）': '平台订单预报',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台订单查询',
    '四级（新）': '平台订单预报'
  },
  {
    序号: 75,
    菜单路由: ' ',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '基础配置 ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台下单配置',
    '四级（新）': ' '
  },
  {
    序号: 76,
    菜单路由: '/portal/poms/basic-config/track-push',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '基础配置 ',
    '3级菜单（旧）': '轨迹推送配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台下单配置',
    '四级（新）': '轨迹推送配置'
  },
  {
    序号: 77,
    菜单路由: '/portal/poms/basic-config/return-reason',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '基础配置 ',
    '3级菜单（旧）': '异常原因配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台下单配置',
    '四级（新）': '异常原因配置'
  },
  {
    序号: 78,
    菜单路由: '/portal/poms/basic-config/track-warning-rules',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '基础配置 ',
    '3级菜单（旧）': '轨迹预警规则',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台下单配置',
    '四级（新）': '轨迹预警规则'
  },
  {
    序号: 79,
    菜单路由: '/portal/poms/basic-config/platform-channel-config',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '基础配置 ',
    '3级菜单（旧）': '平台产品渠道',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台下单配置',
    '四级（新）': '平台产品渠道'
  },
  {
    序号: 80,
    菜单路由: ' ',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '数据推送监控',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台推送监控',
    '四级（新）': ' '
  },
  {
    序号: 81,
    菜单路由: '/portal/poms/tec-track-statistics-report',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '数据推送监控',
    '3级菜单（旧）': '技术侧轨迹统计报表',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台推送监控',
    '四级（新）': '技术侧轨迹统计报表'
  },
  {
    序号: 82,
    菜单路由: '/portal/poms/track-details',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '数据推送监控',
    '3级菜单（旧）': '技术侧轨迹明细报表',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台推送监控',
    '四级（新）': '技术侧轨迹明细报表'
  },
  {
    序号: 83,
    菜单路由: '/portal/poms/track-monitor',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '数据推送监控',
    '3级菜单（旧）': '轨迹数据监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台推送监控',
    '四级（新）': '轨迹数据监控'
  },
  {
    序号: 84,
    菜单路由: '/portal/poms/platform-card-manage',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '数据推送监控',
    '3级菜单（旧）': '亚马逊价卡管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台推送监控',
    '四级（新）': '亚马逊价卡管理'
  },
  {
    序号: 85,
    菜单路由: '/portal/poms/bill-push-manage',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '数据推送监控',
    '3级菜单（旧）': '账单推送管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台推送监控',
    '四级（新）': '账单推送管理'
  },
  {
    序号: 86,
    菜单路由: '/portal/poms/data-push-manage',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '数据推送监控',
    '3级菜单（旧）': '数据推送管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台推送监控',
    '四级（新）': '数据推送管理'
  },
  {
    序号: 87,
    菜单路由: '/portal/poms/track-monitor-report',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '数据推送监控',
    '3级菜单（旧）': '轨迹监控报表',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台推送监控',
    '四级（新）': '轨迹监控报表'
  },
  {
    序号: 88,
    菜单路由: ' ',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '业务配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台业务配置',
    '四级（新）': ' '
  },
  {
    序号: 89,
    菜单路由: '/portal/poms/business-config/1688-container',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '业务配置',
    '3级菜单（旧）': '1688集运件重尺管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台业务配置',
    '四级（新）': '1688集运件重尺管理'
  },
  {
    序号: 90,
    菜单路由: '/portal/poms/business-config/platform-penalty',
    '1级菜单（旧）': '平台订单',
    '2级菜单（旧）': '业务配置',
    '3级菜单（旧）': '平台罚单',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '平台订单管理',
    '三级（新）': '平台业务配置',
    '四级（新）': '平台罚单'
  },
  {
    序号: 441,
    菜单路由: ' ',
    '1级菜单（旧）': '客户营销',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '品牌宣传',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 442,
    菜单路由: ' ',
    '1级菜单（旧）': '客户营销',
    '2级菜单（旧）': '官网后台',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '品牌宣传',
    '三级（新）': '官网后台管理',
    '四级（新）': ' '
  },
  {
    序号: 443,
    菜单路由: '/portal/websiteen/contact-information',
    '1级菜单（旧）': '客户营销',
    '2级菜单（旧）': '官网后台',
    '3级菜单（旧）': '联系信息',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '品牌宣传',
    '三级（新）': '官网后台管理',
    '四级（新）': '联系信息'
  },
  {
    序号: 444,
    菜单路由: '/portal/websiteen/index-carousel',
    '1级菜单（旧）': '客户营销',
    '2级菜单（旧）': '官网后台',
    '3级菜单（旧）': '首页轮播',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '品牌宣传',
    '三级（新）': '官网后台管理',
    '四级（新）': '首页轮播'
  },
  {
    序号: 445,
    菜单路由: '/portal/websiteen/news-infomation',
    '1级菜单（旧）': '客户营销',
    '2级菜单（旧）': '官网后台',
    '3级菜单（旧）': '新闻信息',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '品牌宣传',
    '三级（新）': '官网后台管理',
    '四级（新）': '新闻信息'
  },
  {
    序号: 446,
    菜单路由: '/portal/websiteen/recruitment-information',
    '1级菜单（旧）': '客户营销',
    '2级菜单（旧）': '官网后台',
    '3级菜单（旧）': '招聘信息',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '品牌宣传',
    '三级（新）': '官网后台管理',
    '四级（新）': '招聘信息'
  },
  {
    序号: 447,
    菜单路由: '/portal/websiteen/marketing-advertising',
    '1级菜单（旧）': '客户营销',
    '2级菜单（旧）': '官网后台',
    '3级菜单（旧）': '营销广告',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '品牌宣传',
    '三级（新）': '官网后台管理',
    '四级（新）': '营销广告'
  },
  {
    序号: 448,
    菜单路由: '/portal/websiteen/cooperative-partner',
    '1级菜单（旧）': '客户营销',
    '2级菜单（旧）': '官网后台',
    '3级菜单（旧）': '合作伙伴',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '品牌宣传',
    '三级（新）': '官网后台管理',
    '四级（新）': '合作伙伴'
  },
  {
    序号: 449,
    菜单路由: '/portal/websiteen/platform-entry',
    '1级菜单（旧）': '客户营销',
    '2级菜单（旧）': '官网后台',
    '3级菜单（旧）': '平台入驻',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '品牌宣传',
    '三级（新）': '官网后台管理',
    '四级（新）': '平台入驻'
  },
  {
    序号: 450,
    菜单路由: '/portal/websiteen/production-information',
    '1级菜单（旧）': '客户营销',
    '2级菜单（旧）': '官网后台',
    '3级菜单（旧）': '产品信息',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '品牌宣传',
    '三级（新）': '官网后台管理',
    '四级（新）': '产品信息'
  },
  {
    序号: 451,
    菜单路由: ' ',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 452,
    菜单路由: ' ',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '优惠券',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '优惠券',
    '四级（新）': ' '
  },
  {
    序号: 453,
    菜单路由: '/portal/dmms/coupon-manage',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '优惠券',
    '3级菜单（旧）': '优惠券管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '优惠券',
    '四级（新）': '优惠券管理'
  },
  {
    序号: 454,
    菜单路由: ' ',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '云享卡',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '云享卡',
    '四级（新）': ' '
  },
  {
    序号: 455,
    菜单路由: '/portal/dmms/cloudcard-setting',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '云享卡',
    '3级菜单（旧）': '云享卡折扣设置',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '云享卡',
    '四级（新）': '云享卡折扣设置'
  },
  {
    序号: 456,
    菜单路由: '/portal/dmms/cloudcard-account',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '云享卡',
    '3级菜单（旧）': '云享卡账户',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '云享卡',
    '四级（新）': '云享卡账户'
  },
  {
    序号: 457,
    菜单路由: '/portal/dmms/cloudcard-level',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '云享卡',
    '3级菜单（旧）': '云享卡客户等级',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '云享卡',
    '四级（新）': '云享卡客户等级'
  },
  {
    序号: 458,
    菜单路由: '/portal/dmms/cloudcard-discount',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '云享卡',
    '3级菜单（旧）': '云享卡折扣管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '云享卡',
    '四级（新）': '云享卡折扣管理'
  },
  {
    序号: 459,
    菜单路由: ' ',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '营销活动',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '营销活动',
    '四级（新）': ' '
  },
  {
    序号: 460,
    菜单路由: '/portal/dmms/activity-center',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '营销活动',
    '3级菜单（旧）': '活动中心',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '营销活动',
    '四级（新）': '活动中心'
  },
  {
    序号: 461,
    菜单路由: '/portal/dmms/activity-analysis',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '营销活动',
    '3级菜单（旧）': '活动效果',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '营销活动',
    '四级（新）': '活动效果'
  },
  {
    序号: 462,
    菜单路由: ' ',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '专属码',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '专属码',
    '四级（新）': ' '
  },
  {
    序号: 463,
    菜单路由: '/portal/dmms/suggest-register',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '专属码',
    '3级菜单（旧）': '专属码管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '专属码',
    '四级（新）': '专属码管理'
  },
  {
    序号: 464,
    菜单路由: ' ',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '广告营销',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '广告营销',
    '四级（新）': ' '
  },
  {
    序号: 465,
    菜单路由: '/portal/dmms/message-template',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '广告营销',
    '3级菜单（旧）': '短信模版',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '广告营销',
    '四级（新）': '短信模板'
  },
  {
    序号: 466,
    菜单路由: '/portal/dmms/message-send',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '广告营销',
    '3级菜单（旧）': '短信发送',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '广告营销',
    '四级（新）': '短信发送'
  },
  {
    序号: 467,
    菜单路由: '/portal/dmms/poster-template',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '广告营销',
    '3级菜单（旧）': '宣传模版',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '广告营销',
    '四级（新）': '宣传模板'
  },
  {
    序号: 468,
    菜单路由: '/portal/dmms/poster-send',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '广告营销',
    '3级菜单（旧）': '站内海报发送',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '广告营销',
    '四级（新）': '站内海报发送'
  },
  {
    序号: 469,
    菜单路由: '/portal/dmms/short-link',
    '1级菜单（旧）': '数字营销',
    '2级菜单（旧）': '广告营销',
    '3级菜单（旧）': '短链工具',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '数字营销',
    '三级（新）': '广告营销',
    '四级（新）': '短链工具'
  },
  {
    序号: 584,
    菜单路由: ' ',
    '1级菜单（旧）': '网站配置',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '用户中心配置',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 585,
    菜单路由: '/portal/usercenter/notice-manage',
    '1级菜单（旧）': '网站配置',
    '2级菜单（旧）': '公告与消息管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '用户中心配置',
    '三级（新）': '公告与消息管理',
    '四级（新）': ' '
  },
  {
    序号: 586,
    菜单路由: '/portal/usercenter/policy-manage',
    '1级菜单（旧）': '网站配置',
    '2级菜单（旧）': '协议发布管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '用户中心配置',
    '三级（新）': '协议发布管理',
    '四级（新）': ' '
  },
  {
    序号: 587,
    菜单路由: '/portal/usercenter/policy-type-manage',
    '1级菜单（旧）': '网站配置',
    '2级菜单（旧）': '协议类型管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '用户中心配置',
    '三级（新）': '协议类型管理',
    '四级（新）': ' '
  },
  {
    序号: 588,
    菜单路由: '/portal/usercenter/help-center',
    '1级菜单（旧）': '网站配置',
    '2级菜单（旧）': '帮助中心配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '用户中心配置',
    '三级（新）': '帮助中心配置',
    '四级（新）': ' '
  },
  {
    序号: 589,
    菜单路由: '/portal/usercenter/help-center-uc2',
    '1级菜单（旧）': '网站配置',
    '2级菜单（旧）': '帮助中心-NUC',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '用户中心配置',
    '三级（新）': '帮助中心-NUC',
    '四级（新）': ' '
  },
  {
    序号: 590,
    菜单路由: '/portal/usercenter/question-manage',
    '1级菜单（旧）': '网站配置',
    '2级菜单（旧）': '问卷管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '用户中心配置',
    '三级（新）': '问卷管理',
    '四级（新）': ' '
  },
  {
    序号: 591,
    菜单路由: '/portal/usercenter/qyweixin-group-config',
    '1级菜单（旧）': '网站配置',
    '2级菜单（旧）': '企微群设置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '用户中心配置',
    '三级（新）': '企微群设置',
    '四级（新）': ' '
  },
  {
    序号: 592,
    菜单路由: '/portal/usercenter/short-link-generator',
    '1级菜单（旧）': '网站配置',
    '2级菜单（旧）': '短链生成器',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '用户中心配置',
    '三级（新）': '短链生成器',
    '四级（新）': ' '
  },
  {
    序号: 2101,
    菜单路由: '/portal/oms/stage-order/forecast-order-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '预报订单管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单查询',
    '四级（新）': '预报订单管理'
  },
  {
    序号: 2102,
    菜单路由: '/portal/oms/stage-order/cancel-order-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '取消订单预报',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单查询',
    '四级（新）': '取消订单预报'
  },
  {
    序号: 2103,
    菜单路由: '/portal/oms/stage-order/dictionary-manage',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': '分段订单',
    '3级菜单（旧）': '字典管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': '分段订单管理',
    '三级（新）': '分段订单配置',
    '四级（新）': '字典管理'
  },
  {
    序号: 2104,
    菜单路由: '/portal/oms/B2B-order/abnormal-price-orders',
    '1级菜单（旧）': '订单管理',
    '2级菜单（旧）': 'B5B订单',
    '3级菜单（旧）': '变价异常订单',
    '4级菜单（旧）': ' ',
    '一级（新）': '市场销售',
    '二级（新）': 'B2B订单管理',
    '三级（新）': '变价异常订单',
    '四级（新）': ' '
  },
  {
    序号: 481,
    菜单路由: ' ',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 482,
    菜单路由: ' ',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '运单路由',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '运单路由',
    '四级（新）': ' '
  },
  {
    序号: 483,
    菜单路由: '/portal/lnms/route-manage/transport-order-route',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '运单路由',
    '3级菜单（旧）': '路由查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '运单路由',
    '四级（新）': '路由查询'
  },
  {
    序号: 484,
    菜单路由: '/portal/lnms/route-manage/transport-order-route-details',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '运单路由',
    '3级菜单（旧）': '路由详情',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '运单路由',
    '四级（新）': '路由详情'
  },
  {
    序号: 485,
    菜单路由: '/portal/lnms/route-manage/transport-order-abnormal',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '运单路由',
    '3级菜单（旧）': '路由异常',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '运单路由',
    '四级（新）': '路由异常'
  },
  {
    序号: 486,
    菜单路由: ' ',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次监控',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次监控',
    '四级（新）': ' '
  },
  {
    序号: 487,
    菜单路由: '/portal/lnms/sheet-manage/shift-sheet/operation-shift',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次监控',
    '3级菜单（旧）': '操作班次监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次监控',
    '四级（新）': '操作班次监控'
  },
  {
    序号: 488,
    菜单路由: '/portal/lnms/sheet-manage/shift-sheet/truck-shift',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次监控',
    '3级菜单（旧）': '陆运班次监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次监控',
    '四级（新）': '陆运班次监控'
  },
  {
    序号: 489,
    菜单路由: '/portal/lnms/sheet-manage/shift-sheet/delivery-shift',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次监控',
    '3级菜单（旧）': '派送班次监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次监控',
    '四级（新）': '派送班次监控'
  },
  {
    序号: 490,
    菜单路由: ' ',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次管理',
    '四级（新）': ' '
  },
  {
    序号: 491,
    菜单路由: '/portal/lnms/shift-manage/collect-shift-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次管理',
    '3级菜单（旧）': '揽收班次配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次管理',
    '四级（新）': '揽收班次配置'
  },
  {
    序号: 492,
    菜单路由: '/portal/lnms/shift-manage/operation-shift-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次管理',
    '3级菜单（旧）': '操作班次配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次管理',
    '四级（新）': '操作班次配置'
  },
  {
    序号: 493,
    菜单路由: '/portal/lnms/shift-manage/transport-shift-manage/truck-shift-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次管理',
    '3级菜单（旧）': '陆运班次配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次管理',
    '四级（新）': '陆运班次配置'
  },
  {
    序号: 494,
    菜单路由: '/portal/lnms/shift-manage/transport-shift-manage/airline-shift-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次管理',
    '3级菜单（旧）': '空运班次配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次管理',
    '四级（新）': '空运班次配置'
  },
  {
    序号: 495,
    菜单路由: '/portal/lnms/shift-manage/combination-shift-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次管理',
    '3级菜单（旧）': '组合班次配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次管理',
    '四级（新）': '组合班次配置'
  },
  {
    序号: 496,
    菜单路由: '/portal/lnms/shift-manage/customs-shift-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次管理',
    '3级菜单（旧）': '关务班次配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次管理',
    '四级（新）': '关务班次配置'
  },
  {
    序号: 497,
    菜单路由: '/portal/lnms/shift-manage/delivery-shift-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '班次管理',
    '3级菜单（旧）': '派送班次配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '班次管理',
    '四级（新）': '派送班次配置'
  },
  {
    序号: 498,
    菜单路由: ' ',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '路由管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '路由管理',
    '四级（新）': ' '
  },
  {
    序号: 499,
    菜单路由: '/portal/lnms/route-trial/auto-connect',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '路由管理',
    '3级菜单（旧）': '路由试算',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '路由管理',
    '四级（新）': '路由试算'
  },
  {
    序号: 500,
    菜单路由: '/portal/lnms/route-manage/route-list',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '路由管理',
    '3级菜单（旧）': '路由列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '路由管理',
    '四级（新）': '路由列表'
  },
  {
    序号: 501,
    菜单路由: '/portal/lnms/route-manage/transport-routes',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '路由管理',
    '3级菜单（旧）': '运输线路',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '路由管理',
    '四级（新）': '运输线路'
  },
  {
    序号: 502,
    菜单路由: '/portal/lnms/route-manage/priority-trategy',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '路由管理',
    '3级菜单（旧）': '路由策略',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '路由管理',
    '四级（新）': '路由策略'
  },
  {
    序号: 503,
    菜单路由: '/portal/lnms/basic-data-manage/route-direction',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '路由管理',
    '3级菜单（旧）': '异常路向',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '路由管理',
    '四级（新）': '异常路向'
  },
  {
    序号: 504,
    菜单路由: '/portal/lnms/change-report',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '路由管理',
    '3级菜单（旧）': '变更日志',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '路由管理',
    '四级（新）': '变更日志'
  },
  {
    序号: 505,
    菜单路由: '/portal/lnms/sheet-manage/route-coverage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '路由管理',
    '3级菜单（旧）': '路由覆盖率',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '路由管理',
    '四级（新）': '路由覆盖率'
  },
  {
    序号: 506,
    菜单路由: ' ',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '配置管理',
    '四级（新）': ' '
  },
  {
    序号: 507,
    菜单路由: '/portal/lnms/basic-data-manage/product-ageing-standard',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '产品时效',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '配置管理',
    '四级（新）': '产品时效'
  },
  {
    序号: 508,
    菜单路由: '/portal/lnms/direction-of-destination',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '目的流向',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '配置管理',
    '四级（新）': '目的流向'
  },
  {
    序号: 509,
    菜单路由: ' ',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '时长管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '配置管理',
    '四级（新）': ' '
  },
  {
    序号: 510,
    菜单路由: '/portal/lnms/basic-data-manage/transport-duration',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '时长管理',
    '4级菜单（旧）': '发货-到港',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '配置管理',
    '四级（新）': '发货-到港时长'
  },
  {
    序号: 511,
    菜单路由: '/portal/lnms/basic-data-manage/airport-handling-time',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '时长管理',
    '4级菜单（旧）': '到港-起飞',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '配置管理',
    '四级（新）': '到港-起飞时长'
  },
  {
    序号: 512,
    菜单路由: '/portal/lnms/basic-data-manage/freight-station-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '时长管理',
    '4级菜单（旧）': '落地-NOA',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '配置管理',
    '四级（新）': '落地-NOA时长'
  },
  {
    序号: 513,
    菜单路由: ' ',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '基础数据',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '基础数据',
    '四级（新）': ' '
  },
  {
    序号: 514,
    菜单路由: '/portal/lnms/route-manage/product-route-list',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '基础数据',
    '4级菜单（旧）': '产品属性',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '基础数据',
    '四级（新）': '产品属性'
  },
  {
    序号: 515,
    菜单路由: '/portal/lnms/basic-data-manage/attribute-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '基础数据',
    '4级菜单（旧）': '班次属性',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '基础数据',
    '四级（新）': '班次属性'
  },
  {
    序号: 516,
    菜单路由: '/portal/lnms/basic-data-manage/constraint-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '基础数据',
    '4级菜单（旧）': '班次配载',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '基础数据',
    '四级（新）': '班次配载'
  },
  {
    序号: 517,
    菜单路由: '/portal/lnms/basic-data-manage/route-template-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '基础数据',
    '4级菜单（旧）': '线路模板',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '基础数据',
    '四级（新）': '线路模板'
  },
  {
    序号: 518,
    菜单路由: '/portal/lnms/basic-data-manage/holiday-manage',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '配置管理',
    '3级菜单（旧）': '基础数据',
    '4级菜单（旧）': '节假日',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '基础数据',
    '四级（新）': '节假日'
  },
  {
    序号: 519,
    菜单路由: ' ',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '下载中心',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '下载中心',
    '四级（新）': ' '
  },
  {
    序号: 520,
    菜单路由: '/portal/lnms/import-list',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '下载中心',
    '3级菜单（旧）': '导入列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '下载中心',
    '四级（新）': '导入列表'
  },
  {
    序号: 521,
    菜单路由: '/portal/lnms/export-list',
    '1级菜单（旧）': '网络规划',
    '2级菜单（旧）': '下载中心',
    '3级菜单（旧）': '导出列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '网络管理',
    '二级（新）': '网络规划',
    '三级（新）': '下载中心',
    '四级（新）': '导出列表'
  },
  {
    序号: 156,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 157,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '基础数据',
    '四级（新）': ' '
  },
  {
    序号: 158,
    菜单路由: '/portal/lrms/address-management',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '地址管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '基础数据',
    '四级（新）': '地址管理'
  },
  {
    序号: 159,
    菜单路由: '/portal/lrms/transport-merchant',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '承运商管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '基础数据',
    '四级（新）': '承运商管理'
  },
  {
    序号: 160,
    菜单路由: '/portal/lrms/transport-merchant-rule',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '承运商优先级规则',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '基础数据',
    '四级（新）': '承运商优先级规则'
  },
  {
    序号: 161,
    菜单路由: '/portal/lrms/transport-merchant-offer',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '承运商报价',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '基础数据',
    '四级（新）': '承运商报价'
  },
  {
    序号: 162,
    菜单路由: '/portal/lrms/car-manage',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '车辆管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '基础数据',
    '四级（新）': '车辆管理'
  },
  {
    序号: 163,
    菜单路由: '/portal/lrms/driver-manage',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '司机管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '基础数据',
    '四级（新）': '司机管理'
  },
  {
    序号: 164,
    菜单路由: '/portal/lrms/white-list',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '白名单管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '基础数据',
    '四级（新）': '白名单管理'
  },
  {
    序号: 165,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '询价管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '询价管理',
    '四级（新）': ' '
  },
  {
    序号: 166,
    菜单路由: '/portal/lrms/inquiry-demand',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '询价管理',
    '3级菜单（旧）': '询价管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '询价管理',
    '四级（新）': '询价管理'
  },
  {
    序号: 167,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '邮件管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '邮件管理',
    '四级（新）': ' '
  },
  {
    序号: 168,
    菜单路由: '/portal/lrms/email-list',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '邮件管理',
    '3级菜单（旧）': '邮件列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '邮件管理',
    '四级（新）': '邮件列表'
  },
  {
    序号: 169,
    菜单路由: '/portal/lrms/email-setting',
    '1级菜单（旧）': '陆运资源',
    '2级菜单（旧）': '邮件管理',
    '3级菜单（旧）': '邮件配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '陆运资源开发',
    '三级（新）': '邮件管理',
    '四级（新）': '邮件配置'
  },
  {
    序号: 196,
    菜单路由: ' ',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 197,
    菜单路由: ' ',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '线下治谈舱位',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '线下洽谈舱位',
    '四级（新）': ' '
  },
  {
    序号: 198,
    菜单路由: '/portal/rbs/offline-negotiation-assess',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '线下治谈舱位',
    '3级菜单（旧）': '线下洽谈评估列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '线下洽谈舱位',
    '四级（新）': '线下洽谈评估列表'
  },
  {
    序号: 199,
    菜单路由: '/portal/rbs/offline-negotiation-audit',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '线下治谈舱位',
    '3级菜单（旧）': '线下洽淡审核列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '线下洽谈舱位',
    '四级（新）': '线下洽谈审核列表'
  },
  {
    序号: 200,
    菜单路由: ' ',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '竞价管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '竞价管理',
    '四级（新）': ' '
  },
  {
    序号: 201,
    菜单路由: '/portal/rbs/list',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '竞价管理',
    '3级菜单（旧）': '竞价列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '竞价管理',
    '四级（新）': '竞价列表'
  },
  {
    序号: 202,
    菜单路由: '/portal/rbs/assess',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '竞价管理',
    '3级菜单（旧）': '评估列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '竞价管理',
    '四级（新）': '评估列表'
  },
  {
    序号: 203,
    菜单路由: '/portal/rbs/audit',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '竞价管理',
    '3级菜单（旧）': '审核列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '竞价管理',
    '四级（新）': '审核列表'
  },
  {
    序号: 204,
    菜单路由: ' ',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '议价管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '议价管理',
    '四级（新）': ' '
  },
  {
    序号: 205,
    菜单路由: '/portal/rbs/bargain-list',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '议价管理',
    '3级菜单（旧）': '议价列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '议价管理',
    '四级（新）': '议价列表'
  },
  {
    序号: 206,
    菜单路由: '/portal/rbs/bargain-audit-list',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '议价管理',
    '3级菜单（旧）': '议价审核列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '议价管理',
    '四级（新）': '议价审核列表'
  },
  {
    序号: 207,
    菜单路由: ' ',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '资源管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '资源管理',
    '四级（新）': ' '
  },
  {
    序号: 208,
    菜单路由: '/portal/rbs/bid-resource-list',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '资源管理',
    '3级菜单（旧）': '竞价资源列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '资源管理',
    '四级（新）': '竞价资源列表'
  },
  {
    序号: 209,
    菜单路由: '/portal/rbs/bidding-resource-list',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '资源管理',
    '3级菜单（旧）': '中标资源列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '资源管理',
    '四级（新）': '中标资源列表'
  },
  {
    序号: 210,
    菜单路由: '/portal/rbs/bidding-resource-transaction',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '资源管理',
    '3级菜单（旧）': '中标资源异动',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '资源管理',
    '四级（新）': '中标资源异动'
  },
  {
    序号: 211,
    菜单路由: ' ',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '基础数据',
    '四级（新）': ' '
  },
  {
    序号: 212,
    菜单路由: '/portal/rbs/departure-area',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '起运区域',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '基础数据',
    '四级（新）': '起运区域'
  },
  {
    序号: 213,
    菜单路由: '/portal/rbs/box-weight',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '平均箱重',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '基础数据',
    '四级（新）': '平均箱重'
  },
  {
    序号: 214,
    菜单路由: '/portal/rbs/box-amount',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '板型箱数',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '基础数据',
    '四级（新）': '板型箱数'
  },
  {
    序号: 215,
    菜单路由: '/portal/rbs/service-set',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '服务商设置',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '基础数据',
    '四级（新）': '服务商设置'
  },
  {
    序号: 216,
    菜单路由: '/portal/rbs/volume-coefficient-config',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '材积系数配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '基础数据',
    '四级（新）': '材积系数配置'
  },
  {
    序号: 217,
    菜单路由: '/portal/rbs/route-grouping',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '航线分组',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '基础数据',
    '四级（新）': '航线分组'
  },
  {
    序号: 218,
    菜单路由: '/portal/rbs/AnnouncementManagement',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '公告管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '基础数据',
    '四级（新）': '公告管理'
  },
  {
    序号: 219,
    菜单路由: ' ',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '系统设置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '系统设置',
    '四级（新）': ' '
  },
  {
    序号: 220,
    菜单路由: '/portal/rbs/assess/create-rule',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '系统设置',
    '3级菜单（旧）': '资源生成规则',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '系统设置',
    '四级（新）': '资源生成规则'
  },
  {
    序号: 221,
    菜单路由: '/portal/rbs/create-account',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '系统设置',
    '3级菜单（旧）': '代服务商注册',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '系统设置',
    '四级（新）': '代服务商注册'
  },
  {
    序号: 222,
    菜单路由: '/portal/rbs/audit-config',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '系统设置',
    '3级菜单（旧）': '审核配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '系统设置',
    '四级（新）': '审核配置'
  },
  {
    序号: 223,
    菜单路由: '/portal/rbs/help-guide-config',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '系统设置',
    '3级菜单（旧）': '帮助指引配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '系统设置',
    '四级（新）': '帮助指引配置'
  },
  {
    序号: 224,
    菜单路由: '/portal/rbs/feishu-audit-config',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '系统设置',
    '3级菜单（旧）': '飞书审核配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '系统设置',
    '四级（新）': '飞书审核配置'
  },
  {
    序号: 225,
    菜单路由: ' ',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '操作数据查询',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '操作数据查询',
    '四级（新）': ' '
  },
  {
    序号: 226,
    菜单路由: '/portal/rbs/composite-cost',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '操作数据查询',
    '3级菜单（旧）': '查询综合成本',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '操作数据查询',
    '四级（新）': '查询综合成本'
  },
  {
    序号: 227,
    菜单路由: '/portal/rbs/sent-email',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '操作数据查询',
    '3级菜单（旧）': '已发邮件查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '操作数据查询',
    '四级（新）': '已发邮件查询'
  },
  {
    序号: 228,
    菜单路由: '/portal/rbs/historical-quotation',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '操作数据查询',
    '3级菜单（旧）': '历史报价查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '操作数据查询',
    '四级（新）': '历史报价查询'
  },
  {
    序号: 229,
    菜单路由: ' ',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '供应商绩效评估',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '供应商绩效评估',
    '四级（新）': ' '
  },
  {
    序号: 230,
    菜单路由: '/portal/rbs/performance-assess-template',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '供应商绩效评估',
    '3级菜单（旧）': '绩效评估模板',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '供应商绩效评估',
    '四级（新）': '绩效评估模板'
  },
  {
    序号: 231,
    菜单路由: '/portal/rbs/performance-flow-list',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '供应商绩效评估',
    '3级菜单（旧）': '绩效流水列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '供应商绩效评估',
    '四级（新）': '绩效流水列表'
  },
  {
    序号: 232,
    菜单路由: '/portal/rbs/performance-assess-list',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '供应商绩效评估',
    '3级菜单（旧）': '绩效评估单',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '供应商绩效评估',
    '四级（新）': '绩效评估单'
  },
  {
    序号: 233,
    菜单路由: '/portal/rbs/service-satisfaction',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '供应商绩效评估',
    '3级菜单（旧）': '服务商满意度',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '供应商绩效评估',
    '四级（新）': '服务商满意度'
  },
  {
    序号: 234,
    菜单路由: ' ',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '固定位',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '固定位',
    '四级（新）': ' '
  },
  {
    序号: 235,
    菜单路由: '/portal/rbs/fixed-position',
    '1级菜单（旧）': '航空竞价',
    '2级菜单（旧）': '固定位',
    '3级菜单（旧）': '固定/包机位意向列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源采购',
    '三级（新）': '固定位',
    '四级（新）': '固定/包机位意向列表'
  },
  {
    序号: 236,
    菜单路由: ' ',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 237,
    菜单路由: ' ',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': '基础数据',
    '四级（新）': ' '
  },
  {
    序号: 238,
    菜单路由: '/portal/airlrms/air-resource/airline-management',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '航线管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': '基础数据',
    '四级（新）': '航线管理'
  },
  {
    序号: 239,
    菜单路由: '/portal/airlrms/air-resource/air-board-type',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '航空板型',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': '基础数据',
    '四级（新）': '航空板型'
  },
  {
    序号: 240,
    菜单路由: '/portal/airlrms/air-resource/air-board-weight',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '航空板重',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': '基础数据',
    '四级（新）': '航空板重'
  },
  {
    序号: 241,
    菜单路由: ' ',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': '空运资源管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 242,
    菜单路由: '/portal/airlrms/air-resource/eq-main-resource',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': '空运资源管理',
    '3级菜单（旧）': 'EQ主资源',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': 'EQ主资源',
    '四级（新）': ' '
  },
  {
    序号: 243,
    菜单路由: '/portal/airlrms/air-resource/resource-management',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': '空运资源管理',
    '3级菜单（旧）': '资源管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': '资源管理',
    '四级（新）': ' '
  },
  {
    序号: 244,
    菜单路由: '/portal/airlrms/air-resource/fixed-cabin',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': '空运资源管理',
    '3级菜单（旧）': '固定舱位',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': '固定舱位',
    '四级（新）': ' '
  },
  {
    序号: 245,
    菜单路由: '/portal/airlrms/air-resource/cost-change-list',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': '空运资源管理',
    '3级菜单（旧）': '成本变更列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': '成本变更列表',
    '四级（新）': ' '
  },
  {
    序号: 246,
    菜单路由: '/portal/airlrms/air-resource/shipping-space-change-list',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': '空运资源管理',
    '3级菜单（旧）': '舱位变更列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': '舱位变更列表',
    '四级（新）': ' '
  },
  {
    序号: 247,
    菜单路由: '/portal/airlrms/air-resource/extra-fee-change',
    '1级菜单（旧）': '空运资源',
    '2级菜单（旧）': '空运资源管理',
    '3级菜单（旧）': '杂费套餐变更列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '空运资源管理',
    '三级（新）': '杂费套餐变更列表',
    '四级（新）': ' '
  },
  {
    序号: 470,
    菜单路由: ' ',
    '1级菜单（旧）': '资源容量',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '资源容量管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 471,
    菜单路由: ' ',
    '1级菜单（旧）': '资源容量',
    '2级菜单（旧）': '场地资源',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '资源容量管理',
    '三级（新）': '场地资源',
    '四级（新）': ' '
  },
  {
    序号: 472,
    菜单路由: '/portal/rcms/area-manage/operating-outlet',
    '1级菜单（旧）': '资源容量',
    '2级菜单（旧）': '场地资源',
    '3级菜单（旧）': '网点管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '资源容量管理',
    '三级（新）': '场地资源',
    '四级（新）': '网点管理'
  },
  {
    序号: 473,
    菜单路由: '/portal/rcms/area-manage/airport',
    '1级菜单（旧）': '资源容量',
    '2级菜单（旧）': '场地资源',
    '3级菜单（旧）': '机场管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '资源容量管理',
    '三级（新）': '场地资源',
    '四级（新）': '机场管理'
  },
  {
    序号: 474,
    菜单路由: '/portal/rcms/area-manage/harbor',
    '1级菜单（旧）': '资源容量',
    '2级菜单（旧）': '场地资源',
    '3级菜单（旧）': '港口管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '资源容量管理',
    '三级（新）': '场地资源',
    '四级（新）': '港口管理'
  },
  {
    序号: 475,
    菜单路由: '/portal/rcms/area-manage/port',
    '1级菜单（旧）': '资源容量',
    '2级菜单（旧）': '场地资源',
    '3级菜单（旧）': '口岸管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '资源容量管理',
    '三级（新）': '场地资源',
    '四级（新）': '口岸管理'
  },
  {
    序号: 476,
    菜单路由: ' ',
    '1级菜单（旧）': '资源容量',
    '2级菜单（旧）': '服务商资源',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '资源容量管理',
    '三级（新）': '服务商资源',
    '四级（新）': ' '
  },
  {
    序号: 477,
    菜单路由: '/portal/rcms/end-server-net-manage',
    '1级菜单（旧）': '资源容量',
    '2级菜单（旧）': '服务商资源',
    '3级菜单（旧）': '末端服务商网点',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '资源容量管理',
    '三级（新）': '服务商资源',
    '四级（新）': '末端服务商网点'
  },
  {
    序号: 478,
    菜单路由: ' ',
    '1级菜单（旧）': '资源容量',
    '2级菜单（旧）': '末端资源',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '资源容量管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 479,
    菜单路由: '/portal/rcms/channel-manage/delivery-manage',
    '1级菜单（旧）': '资源容量',
    '2级菜单（旧）': '末端资源',
    '3级菜单（旧）': '服务渠道',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '资源容量管理',
    '三级（新）': '服务商资源',
    '四级（新）': '服务渠道同步'
  },
  {
    序号: 480,
    菜单路由: '/portal/rcms/push-record',
    '1级菜单（旧）': '资源容量',
    '2级菜单（旧）': '数据推送',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '资源管理',
    '二级（新）': '资源容量管理',
    '三级（新）': '数据推送',
    '四级（新）': ' '
  },
  {
    序号: 435,
    菜单路由: ' ',
    '1级菜单（旧）': '提成返点',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '结算管理',
    '二级（新）': '客户返点账单',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 436,
    菜单路由: '/portal/crms/rule-config',
    '1级菜单（旧）': '提成返点',
    '2级菜单（旧）': '规则配置管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '结算管理',
    '二级（新）': '客户返点账单',
    '三级（新）': '规则配置管理',
    '四级（新）': ' '
  },
  {
    序号: 437,
    菜单路由: '/portal/crms/object-bind',
    '1级菜单（旧）': '提成返点',
    '2级菜单（旧）': '对象绑定管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '结算管理',
    '二级（新）': '客户返点账单',
    '三级（新）': '对象绑定管理',
    '四级（新）': ' '
  },
  {
    序号: 438,
    菜单路由: '/portal/crms/bill-data',
    '1级菜单（旧）': '提成返点',
    '2级菜单（旧）': '账单数据管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '结算管理',
    '二级（新）': '客户返点账单',
    '三级（新）': '账单数据管理',
    '四级（新）': ' '
  },
  {
    序号: 439,
    菜单路由: '/portal/crms/rebate-bill',
    '1级菜单（旧）': '提成返点',
    '2级菜单（旧）': '返点账单管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '结算管理',
    '二级（新）': '客户返点账单',
    '三级（新）': '返点账单管理',
    '四级（新）': ' '
  },
  {
    序号: 440,
    菜单路由: '/portal/crms/bill-download',
    '1级菜单（旧）': '提成返点',
    '2级菜单（旧）': '账单下载',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '结算管理',
    '二级（新）': '客户返点账单',
    '三级（新）': '账单下载',
    '四级（新）': ' '
  },
  {
    序号: 2117,
    菜单路由: ' ',
    '1级菜单（旧）': '客户催收',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '结算管理',
    '二级（新）': '客户催收',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2118,
    菜单路由: '/portal/lars/yt-customer-collect-manage',
    '1级菜单（旧）': '客户催收',
    '2级菜单（旧）': '云途催收管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '结算管理',
    '二级（新）': '客户催收',
    '三级（新）': '云途催收管理',
    '四级（新）': ' '
  },
  {
    序号: 2119,
    菜单路由: '/portal/lars/wt-customer-collect-manage',
    '1级菜单（旧）': '客户催收',
    '2级菜单（旧）': '沃太催收管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '结算管理',
    '二级（新）': '客户催收',
    '三级（新）': '沃太催收管理',
    '四级（新）': ' '
  },
  {
    序号: 522,
    菜单路由: ' ',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 523,
    菜单路由: 'http://logistics-control.eminxing.com/monitor/dataScreen/#/dataScreen',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '驾驶舱',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '驾驶舱',
    '四级（新）': ' '
  },
  {
    序号: 524,
    菜单路由: '/portal/lct/abnormal-monitor/link-monitor-board',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '监控看板',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '监控看板',
    '四级（新）': ' '
  },
  {
    序号: 525,
    菜单路由: ' ',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': ' '
  },
  {
    序号: 526,
    菜单路由: '/portal/lct/abnormal-monitor/link-total-dashboard',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '环节监控汇总看板',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '环节监控汇总'
  },
  {
    序号: 527,
    菜单路由: '/portal/lct/abnormal-monitor/package-checkout-monitoring',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '包裹签出监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '包裹签出监控'
  },
  {
    序号: 528,
    菜单路由: '/portal/lct/abnormal-monitor/warehouse-allocation',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '仓间调拨监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '仓间调拨监控'
  },
  {
    序号: 529,
    菜单路由: '/portal/lct/abnormal-monitor/pass-through-link',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '过机环节监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '过机环节监控'
  },
  {
    序号: 530,
    菜单路由: '/portal/lct/abnormal-monitor/pass-through-machine',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '发货环节监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '发货环节监控'
  },
  {
    序号: 531,
    菜单路由: '/portal/lct/abnormal-monitor/delivery-port',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '到港环节监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '到港环节监控'
  },
  {
    序号: 532,
    菜单路由: '/portal/lct/delivery-to-arrival/flight-take-off',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '航班起飞监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '航班起飞监控'
  },
  {
    序号: 533,
    菜单路由: '/portal/lct/abnormal-monitor/flight-arrival',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '航班抵达监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '航班抵达监控'
  },
  {
    序号: 534,
    菜单路由: '/portal/lct/abnormal-monitor/delivery-notice',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '提货通知监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '提货通知监控'
  },
  {
    序号: 535,
    菜单路由: '/portal/lct/abnormal-monitor/airport-pickup',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '机场提货监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '机场提货监控'
  },
  {
    序号: 536,
    菜单路由: '/portal/lct/abnormal-monitor/clearance-link',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '清关环节监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '清关环节监控'
  },
  {
    序号: 537,
    菜单路由: '/portal/lct/abnormal-monitor/delivery-warehousing',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '提货入仓监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '提货入仓监控'
  },
  {
    序号: 538,
    菜单路由: '/portal/lct/abnormal-monitor/warehouse-transfer',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '仓间中转监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '仓间中转监控'
  },
  {
    序号: 539,
    菜单路由: '/portal/lct/abnormal-monitor/monitor-warehousing',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '仓库运作监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '仓库运作监控'
  },
  {
    序号: 540,
    菜单路由: '/portal/lct/abnormal-monitor/delivery-end',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '交货末端监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '交货末端监控'
  },
  {
    序号: 541,
    菜单路由: '/portal/lct/abnormal-monitor/end-pickup',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '末端提取监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '末端提取监控'
  },
  {
    序号: 542,
    菜单路由: '/portal/lct/abnormal-monitor/delivered-link',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '环节实时监控',
    '3级菜单（旧）': '妥投环节监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '环节实时监控',
    '四级（新）': '妥投环节监控'
  },
  {
    序号: 543,
    菜单路由: ' ',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '运营分析报表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '运营分析报表',
    '四级（新）': ' '
  },
  {
    序号: 544,
    菜单路由: '/portal/lct/report-analysis/appropriately-monitoring',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '运营分析报表',
    '3级菜单（旧）': '妥投达标率报表',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '运营分析报表',
    '四级（新）': '妥投达标率报表'
  },
  {
    序号: 545,
    菜单路由: '/portal/lct/report-analysis/shared-monitoring',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '运营分析报表',
    '3级菜单（旧）': '共享质控日报表',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '运营分析报表',
    '四级（新）': '共享质控日报表'
  },
  {
    序号: 546,
    菜单路由: '/portal/lct/report-analysis/terminatio-monitoring',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '运营分析报表',
    '3级菜单（旧）': '末端提取日报表',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '运营分析报表',
    '四级（新）': '末端提取日报表'
  },
  {
    序号: 547,
    菜单路由: '/portal/lct/report-analysis/delivery-process',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '运营分析报表',
    '3级菜单（旧）': '妥投环节日报表',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '运营分析报表',
    '四级（新）': '妥投环节日报表'
  },
  {
    序号: 548,
    菜单路由: '/portal/lct/report-analysis/port-line-board',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '运营分析报表',
    '3级菜单（旧）': '口岸跟线监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '运营分析报表',
    '四级（新）': '口岸监控表'
  },
  {
    序号: 549,
    菜单路由: '/portal/lct/report-analysis/waybill-monitoring',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '运营分析报表',
    '3级菜单（旧）': 'G2G-EU运单监控',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '运营分析报表',
    '四级（新）': 'G2G-EU运单监控'
  },
  {
    序号: 550,
    菜单路由: '/portal/lct/report-analysis/push-feishu-daily',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '运营分析报表',
    '3级菜单（旧）': '推送飞书日报台账',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '运营分析报表',
    '四级（新）': '飞书日报台账'
  },
  {
    序号: 551,
    菜单路由: '/portal/lct/report-analysis/quality-control-abnormal-ledger',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '运营分析报表',
    '3级菜单（旧）': '质控异常台账',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '运营分析报表',
    '四级（新）': '运营异常台账'
  },
  {
    序号: 552,
    菜单路由: ' ',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': ' '
  },
  {
    序号: 553,
    菜单路由: '/portal/lct/end-standard-setting',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': '配置末端时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': '配置末端时效标准'
  },
  {
    序号: 554,
    菜单路由: '/portal/lct/checkout-time-limit-standard',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': '签出过机时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': '签出过机时效标准'
  },
  {
    序号: 555,
    菜单路由: '/portal/lct/pass-through-machine-standard',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': '过机发货时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': '过机发货时效标准'
  },
  {
    序号: 556,
    菜单路由: '/portal/lct/delivery-port-standard',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': '发货到港时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': '发货到港时效标准'
  },
  {
    序号: 557,
    菜单路由: '/portal/lct/flight-take-off-standard',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': '航班起飞时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': '航班起飞时效标准'
  },
  {
    序号: 558,
    菜单路由: '/portal/lct/flight-exception',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': '航班异常时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': '航班异常时效标准'
  },
  {
    序号: 559,
    菜单路由: '/portal/lct/noa-abnormal',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': 'NOA异常时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': 'NOA异常时效标准'
  },
  {
    序号: 560,
    菜单路由: '/portal/lct/customs-abnormal',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': '提货异常时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': '提货异常时效标准'
  },
  {
    序号: 561,
    菜单路由: '/portal/lct/clearance-abnormal',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': '清关异常时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': '清关异常时效标准'
  },
  {
    序号: 562,
    菜单路由: '/portal/lct/warehouse-transfer-standard',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': '仓间中转时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': '仓间中转时效标准'
  },
  {
    序号: 563,
    菜单路由: '/portal/lct/warehouse-operation',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': '库内操作时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': '库内操作时效标准'
  },
  {
    序号: 564,
    菜单路由: '/portal/lct/warehouse-delivery-standard',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '时效标准配置',
    '3级菜单（旧）': '仓库交货时效标准',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '时效标准配置',
    '四级（新）': '仓库交货时效标准'
  },
  {
    序号: 565,
    菜单路由: ' ',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '操作中断监控',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断监控',
    '四级（新）': ' '
  },
  {
    序号: 566,
    菜单路由: '/portal/lct/package-lifecycle/package-monitoring',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '操作中断监控',
    '3级菜单（旧）': 'C2G网点操作中断',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断监控',
    '四级（新）': 'C2G网点操作中断'
  },
  {
    序号: 567,
    菜单路由: '/portal/lct/package-lifecycle/c2g-country-flow-monitoring',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '操作中断监控',
    '3级菜单（旧）': 'C2G国家操作中断',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断监控',
    '四级（新）': 'C2G国家操作中断'
  },
  {
    序号: 568,
    菜单路由: '/portal/lct/package-lifecycle/c2g-operation-break-define',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '操作中断监控',
    '3级菜单（旧）': 'C2G操作中断自定义',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断监控',
    '四级（新）': 'C2G操作中断自定义'
  },
  {
    序号: 569,
    菜单路由: '/portal/lct/package-lifecycle/insure-package-monitoring',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '操作中断监控',
    '3级菜单（旧）': '保价网点操作中断',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断监控',
    '四级（新）': '保价网点操作中断'
  },
  {
    序号: 570,
    菜单路由: '/portal/lct/package-lifecycle/g2g-package-monitoring',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '操作中断监控',
    '3级菜单（旧）': 'G2G网点操作中断',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断监控',
    '四级（新）': 'G2G网点操作中断'
  },
  {
    序号: 571,
    菜单路由: '/portal/lct/package-lifecycle/package-lifecycle-analysis',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '操作中断监控',
    '3级菜单（旧）': 'C2G月度操作中断',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断监控',
    '四级（新）': 'C2G月度操作中断'
  },
  {
    序号: 572,
    菜单路由: '/portal/lct/package-lifecycle/major-exception-ledger',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '操作中断监控',
    '3级菜单（旧）': '重大异常台账',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断监控',
    '四级（新）': '重大异常台账'
  },
  {
    序号: 573,
    菜单路由: ' ',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '异常类型定义',
    '四级（新）': ' '
  },
  {
    序号: 574,
    菜单路由: '/portal/lct/exception-type',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '异常类型维护',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '异常类型定义',
    '四级（新）': '异常类型配置'
  },
  {
    序号: 575,
    菜单路由: '/portal/lct/sys-exception-maintenance',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '上游异常同步',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '异常类型定义',
    '四级（新）': '上游异常同步'
  },
  {
    序号: 576,
    菜单路由: ' ',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '重大异常配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断配置',
    '四级（新）': ' '
  },
  {
    序号: 577,
    菜单路由: '/portal/lct/notice-rule',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '重大异常配置',
    '3级菜单（旧）': '预警规则配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断配置',
    '四级（新）': '预警规则配置'
  },
  {
    序号: 578,
    菜单路由: '/portal/lct/upgrade-responsibility-organization',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '重大异常配置',
    '3级菜单（旧）': '主责任人配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断配置',
    '四级（新）': '主责任人配置'
  },
  {
    序号: 579,
    菜单路由: '/portal/lct/main-responsible-department',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '重大异常配置',
    '3级菜单（旧）': '主责部门配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断配置',
    '四级（新）': '主责部门配置'
  },
  {
    序号: 580,
    菜单路由: '/portal/lct/set-verification-node',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '重大异常配置',
    '3级菜单（旧）': '核销节点配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断配置',
    '四级（新）': '核销节点配置'
  },
  {
    序号: 581,
    菜单路由: '/portal/lct/event-task-follow',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '重大异常配置',
    '3级菜单（旧）': '预警推送记录',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '操作中断监控',
    '四级（新）': '预警推送记录'
  },
  {
    序号: 582,
    菜单路由: '/portal/lct/push-group-rule',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '重大异常配置',
    '3级菜单（旧）': '预警群配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '重大异常配置',
    '四级（新）': '推送群配置'
  },
  {
    序号: 583,
    菜单路由: '/portal/lct/message-template',
    '1级菜单（旧）': '物流控制塔',
    '2级菜单（旧）': '重大异常配置',
    '3级菜单（旧）': '消息模板配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '质量管理',
    '二级（新）': 'B2C运营管理',
    '三级（新）': '重大异常配置',
    '四级（新）': '推送模板配置'
  },
  {
    序号: 91,
    菜单路由: ' ',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 92,
    菜单路由: ' ',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '正向履约管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '客户订单履约',
    '四级（新）': ' '
  },
  {
    序号: 93,
    菜单路由: '/portal/ofp/order-task-manage',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '正向履约管理',
    '3级菜单（旧）': '正向任务管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '客户订单履约',
    '四级（新）': '正向任务管理'
  },
  {
    序号: 94,
    菜单路由: ' ',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '异常履约管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 95,
    菜单路由: '/portal/ofp/abnormal-task',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '异常履约管理',
    '3级菜单（旧）': '异常管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '客户订单履约',
    '四级（新）': '异常任务管理'
  },
  {
    序号: 96,
    菜单路由: '/portal/ofp/block-import',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '异常履约管理',
    '3级菜单（旧）': '拦截导入和取消',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '客户订单履约',
    '四级（新）': '拦截导入和取消'
  },
  {
    序号: 97,
    菜单路由: '/portal/ofp/abnormal-task-search',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '异常履约管理',
    '3级菜单（旧）': '异常任务查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '客户订单履约',
    '四级（新）': '异常任务查询'
  },
  {
    序号: 98,
    菜单路由: ' ',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约规则管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约基础配置',
    '四级（新）': ' '
  },
  {
    序号: 99,
    菜单路由: '/portal/ofp/abnormal-process',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约规则管理',
    '3级菜单（旧）': '异常流程管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约基础配置',
    '四级（新）': '异常流程管理'
  },
  {
    序号: 100,
    菜单路由: '/portal/ofp/create-rules',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约规则管理',
    '3级菜单（旧）': '订单任务生成规则',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约基础配置',
    '四级（新）': '订单任务生成规则'
  },
  {
    序号: 101,
    菜单路由: '/portal/ofp/distribute-rules',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约规则管理',
    '3级菜单（旧）': '任务下发规则',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约基础配置',
    '四级（新）': '任务下发规则'
  },
  {
    序号: 102,
    菜单路由: ' ',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '基础信息管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约基础配置',
    '四级（新）': ' '
  },
  {
    序号: 103,
    菜单路由: '/portal/ofp/abnormal-catalogues',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '基础信息管理',
    '3级菜单（旧）': '异常目录管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约基础配置',
    '四级（新）': '异常目录管理'
  },
  {
    序号: 104,
    菜单路由: '/portal/ofp/abnormal-types',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '基础信息管理',
    '3级菜单（旧）': '异常类型管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约基础配置',
    '四级（新）': '异常类型管理'
  },
  {
    序号: 105,
    菜单路由: '/portal/ofp/task-types',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '基础信息管理',
    '3级菜单（旧）': '任务类型管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约基础配置',
    '四级（新）': '任务类型管理'
  },
  {
    序号: 106,
    菜单路由: '/portal/ofp/service-type',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '基础信息管理',
    '3级菜单（旧）': '服务类型管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约基础配置',
    '四级（新）': '服务类型管理'
  },
  {
    序号: 107,
    菜单路由: '/portal/ofp/server-unit-setting',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '基础信息管理',
    '3级菜单（旧）': '服务单元配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约基础配置',
    '四级（新）': '服务单元配置'
  },
  {
    序号: 108,
    菜单路由: '/portal/ofp/server-type-setting',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '基础信息管理',
    '3级菜单（旧）': '服务类型配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约基础配置',
    '四级（新）': '服务类型配置'
  },
  {
    序号: 109,
    菜单路由: ' ',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约流程管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约流程管理',
    '四级（新）': ' '
  },
  {
    序号: 110,
    菜单路由: '/portal/ofp/ofp-process-handle',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约流程管理',
    '3级菜单（旧）': '履约流程处理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约流程管理',
    '四级（新）': '履约流程处理'
  },
  {
    序号: 111,
    菜单路由: '/portal/ofp/ofp-task-instance',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约流程管理',
    '3级菜单（旧）': '履约任务实例',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约流程管理',
    '四级（新）': '履约任务实例'
  },
  {
    序号: 112,
    菜单路由: '/portal/ofp/ofp-mq-consumption',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约流程管理',
    '3级菜单（旧）': 'MQ消费情况',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约流程管理',
    '四级（新）': 'MQ消费情况'
  },
  {
    序号: 113,
    菜单路由: '/portal/ofp/process-record-playback',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约流程管理',
    '3级菜单（旧）': '流程录制和回放',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约流程管理',
    '四级（新）': '流程录制和回放'
  },
  {
    序号: 114,
    菜单路由: '/portal/ofp/warning-block-rule',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约流程管理',
    '3级菜单（旧）': '预警屏蔽规则',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约流程管理',
    '四级（新）': '预警屏蔽规则'
  },
  {
    序号: 115,
    菜单路由: '/portal/ofp/process-definition',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约流程管理',
    '3级菜单（旧）': '流程定义管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约流程管理',
    '四级（新）': '流程定义管理'
  },
  {
    序号: 116,
    菜单路由: '/portal/ofp/task-definition',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约流程管理',
    '3级菜单（旧）': '任务定义管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约流程管理',
    '四级（新）': '任务定义管理'
  },
  {
    序号: 117,
    菜单路由: '/portal/ofp/process-orchestration-definition',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '履约流程管理',
    '3级菜单（旧）': '任务编排定义管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '履约流程管理',
    '四级（新）': '任务编排定义管理'
  },
  {
    序号: 118,
    菜单路由: '/portal/ofp/import-record-query',
    '1级菜单（旧）': '订单履约',
    '2级菜单（旧）': '导入记录查询',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '订单履约',
    '三级（新）': '客户订单履约',
    '四级（新）': '导入记录查询'
  },
  {
    序号: 170,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 171,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输任务创建',
    '四级（新）': ' '
  },
  {
    序号: 172,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': '运输管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 173,
    菜单路由: '/portal/tms/transfer-transport/transport-demand',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': '运输管理',
    '4级菜单（旧）': '运输需求',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输任务创建',
    '四级（新）': '运输需求'
  },
  {
    序号: 174,
    菜单路由: '/portal/tms/transfer-transport/transport-order',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': '运输管理',
    '4级菜单（旧）': '运输订单',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输任务创建',
    '四级（新）': '运输订单'
  },
  {
    序号: 175,
    菜单路由: '/portal/tms/transfer-transport/transport-task',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': '运输管理',
    '4级菜单（旧）': '运输任务',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输任务创建',
    '四级（新）': '运输任务'
  },
  {
    序号: 176,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': '邮件管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 177,
    菜单路由: '/portal/tms/transfer-transport/email-list',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': '邮件管理',
    '4级菜单（旧）': '邮件列表',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输任务创建',
    '四级（新）': '邮件列表'
  },
  {
    序号: 178,
    菜单路由: '/portal/tms/transfer-transport/email-setting',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': '邮件管理',
    '4级菜单（旧）': '邮件配置',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输任务创建',
    '四级（新）': '邮件配置'
  },
  {
    序号: 179,
    菜单路由: '/portal/tms/transfer-transport/transport-task-new',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': '运输任务-新',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输任务创建',
    '四级（新）': '运输任务-新'
  },
  {
    序号: 180,
    菜单路由: '/portal/tms/import-list',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': '导入记录查询',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输任务创建',
    '四级（新）': '导入记录查询'
  },
  {
    序号: 181,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': '基础数据',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 182,
    菜单路由: '/portal/tms/transfer-transport/line-management',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转运输',
    '3级菜单（旧）': '基础数据',
    '4级菜单（旧）': '线路管理',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输任务创建',
    '四级（新）': '线路管理'
  },
  {
    序号: 183,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '干线运输',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '卡班运输',
    '四级（新）': ' '
  },
  {
    序号: 184,
    菜单路由: '/portal/tms/groundline-transport/groundline-transport',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '干线运输',
    '3级菜单（旧）': '干线运输',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '卡班运输',
    '四级（新）': '干线运输'
  },
  {
    序号: 185,
    菜单路由: '/portal/tms/performance-manage',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '履约任务管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '履约任务管理',
    '四级（新）': ' '
  },
  {
    序号: 186,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输管理',
    '四级（新）': ' '
  },
  {
    序号: 187,
    菜单路由: '/portal/tms/transit/transit-demond-manage',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转管理',
    '3级菜单（旧）': '中转运输需求管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输管理',
    '四级（新）': '中转运输需求管理'
  },
  {
    序号: 188,
    菜单路由: '/portal/tms/transit/transit-exception-manage',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转管理',
    '3级菜单（旧）': '中转运输异常管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输管理',
    '四级（新）': '中转运输异常管理'
  },
  {
    序号: 189,
    菜单路由: '/portal/tms/transit/transit-task-manage',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转管理',
    '3级菜单（旧）': '中转任务管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输管理',
    '四级（新）': '中转任务管理'
  },
  {
    序号: 190,
    菜单路由: '/portal/tms/transit/transit-class-manage',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '中转管理',
    '3级菜单（旧）': '中转运输班次管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '运输管理',
    '四级（新）': '中转运输班次管理'
  },
  {
    序号: 191,
    菜单路由: ' ',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '补录管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '补录管理',
    '四级（新）': ' '
  },
  {
    序号: 192,
    菜单路由: '/portal/tms/supplement-manage/supplement-delivery',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '补录管理',
    '3级菜单（旧）': ' 交货末端时间采纳',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '补录管理',
    '四级（新）': ' 交货末端时间采纳'
  },
  {
    序号: 193,
    菜单路由: '/portal/tms/supplement-manage/delivery-end-time-setting',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '补录管理',
    '3级菜单（旧）': '交货末端时间配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '补录管理',
    '四级（新）': '交货末端时间配置'
  },
  {
    序号: 194,
    菜单路由: '/portal/tms/transit/dts-transfer-plan',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '调拨计划',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': 'B2B调拨计划',
    '四级（新）': ' '
  },
  {
    序号: 195,
    菜单路由: '/portal/tms/transit/oversea-dts-transfer-plan',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '送货计划',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': 'B2B发货计划',
    '四级（新）': ' '
  },
  {
    序号: 248,
    菜单路由: ' ',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 249,
    菜单路由: ' ',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '发货计划',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '发货计划',
    '四级（新）': ' '
  },
  {
    序号: 250,
    菜单路由: '/portal/airtms/delivery-plan/create-delivery-plan',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '发货计划',
    '3级菜单（旧）': '创建发货计划',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '发货计划',
    '四级（新）': '创建发货计划'
  },
  {
    序号: 251,
    菜单路由: '/portal/airtms/delivery-plan/delivery-plan-list',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '发货计划',
    '3级菜单（旧）': '发货计划列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '发货计划',
    '四级（新）': '发货计划列表'
  },
  {
    序号: 252,
    菜单路由: '/portal/airtms/delivery-plan/shipping-virtual-resource',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '发货计划',
    '3级菜单（旧）': '发货虚拟资源',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '发货计划',
    '四级（新）': '发货虚拟资源'
  },
  {
    序号: 253,
    菜单路由: '/portal/airtms/delivery-plan/batch-info',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '发货计划',
    '3级菜单（旧）': '批次信息',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '发货计划',
    '四级（新）': '批次信息'
  },
  {
    序号: 254,
    菜单路由: '/portal/airtms/box-load-board',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '发货计划',
    '3级菜单（旧）': '成品箱装载看板',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '发货计划',
    '四级（新）': '成品箱装载看板'
  },
  {
    序号: 255,
    菜单路由: '/portal/airtms/box-load-detail',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '发货计划',
    '3级菜单（旧）': '成品箱装载明细',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '发货计划',
    '四级（新）': '成品箱装载明细'
  },
  {
    序号: 256,
    菜单路由: '/portal/airtms/delivery-plan/air-load',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '发货计划',
    '3级菜单（旧）': '空运配载',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '发货计划',
    '四级（新）': '空运配载'
  },
  {
    序号: 257,
    菜单路由: ' ',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '配板管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '配板管理',
    '四级（新）': ' '
  },
  {
    序号: 258,
    菜单路由: '/portal/airtms/matching-board-manage/air-matching-board',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '配板管理',
    '3级菜单（旧）': '空运配板列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '配板管理',
    '四级（新）': '空运配板列表'
  },
  {
    序号: 259,
    菜单路由: '/portal/airtms/matching-board-manage/create-matching-board',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '配板管理',
    '3级菜单（旧）': '创建空运配板',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '配板管理',
    '四级（新）': '创建空运配板'
  },
  {
    序号: 260,
    菜单路由: ' ',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '订舱管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '订舱管理',
    '四级（新）': ' '
  },
  {
    序号: 261,
    菜单路由: '/portal/airtms/booking-space-manage/booking-space',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '订舱管理',
    '3级菜单（旧）': '空运订舱',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '订舱管理',
    '四级（新）': '空运订舱'
  },
  {
    序号: 262,
    菜单路由: ' ',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '提单管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '提单管理',
    '四级（新）': ' '
  },
  {
    序号: 263,
    菜单路由: '/portal/airtms/pick-order-manage/air-warehouse-bag',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '提单管理',
    '3级菜单（旧）': '空运提单留仓列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '提单管理',
    '四级（新）': '空运提单留仓列表'
  },
  {
    序号: 264,
    菜单路由: '/portal/airtms/pick-order-manage/air-waybill',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '提单管理',
    '3级菜单（旧）': '空运提单',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '提单管理',
    '四级（新）': '空运提单'
  },
  {
    序号: 265,
    菜单路由: '/portal/airtms/pick-order-manage/air-waybill-unplanned',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '提单管理',
    '3级菜单（旧）': '空运提单(无计划)',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '提单管理',
    '四级（新）': '空运提单(无计划)'
  },
  {
    序号: 266,
    菜单路由: '/portal/airtms/pick-order-manage/main-order',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '提单管理',
    '3级菜单（旧）': '主提单管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '提单管理',
    '四级（新）': '主提单管理'
  },
  {
    序号: 267,
    菜单路由: ' ',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '异常管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '异常管理',
    '四级（新）': ' '
  },
  {
    序号: 268,
    菜单路由: '/portal/airtms/exception-manage/exception-reason-setting',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '异常管理',
    '3级菜单（旧）': '异常原因配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '异常管理',
    '四级（新）': '异常原因配置'
  },
  {
    序号: 269,
    菜单路由: '/portal/airtms/exception-manage/shipment-exception',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '异常管理',
    '3级菜单（旧）': '发货异常管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '异常管理',
    '四级（新）': '发货异常管理'
  },
  {
    序号: 270,
    菜单路由: '/portal/airtms/exception-manage/air-exception',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '异常管理',
    '3级菜单（旧）': '空运异常管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '异常管理',
    '四级（新）': '空运异常管理'
  },
  {
    序号: 271,
    菜单路由: ' ',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '申请管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '申请管理',
    '四级（新）': ' '
  },
  {
    序号: 272,
    菜单路由: '/portal/airtms/apply-manage/server-apply',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '申请管理',
    '3级菜单（旧）': '服务商申请',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '申请管理',
    '四级（新）': '服务商申请'
  },
  {
    序号: 273,
    菜单路由: '/portal/airtms/apply-manage/my-apply',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '申请管理',
    '3级菜单（旧）': '我的申请',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '申请管理',
    '四级（新）': '我的申请'
  },
  {
    序号: 274,
    菜单路由: ' ',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': ' '
  },
  {
    序号: 275,
    菜单路由: '/portal/airtms/board-layout-plan/service-manage',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '服务商管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': '服务商管理'
  },
  {
    序号: 276,
    菜单路由: '/portal/airtms/board-layout-plan/booking-template',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': 'Booking模板',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': 'Booking模板'
  },
  {
    序号: 277,
    菜单路由: '/portal/airtms/board-layout-plan/pick-order-sender',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '提单发货人',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': '提单发货人'
  },
  {
    序号: 278,
    菜单路由: '/portal/airtms/board-layout-plan/product-descrip',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '商品描述管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': '商品描述管理'
  },
  {
    序号: 279,
    菜单路由: '/portal/airtms/board-layout-plan/FS-message',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '飞书消息配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': '飞书消息配置'
  },
  {
    序号: 280,
    菜单路由: '/portal/airtms/delivery-plan/service-delivery-warehouse',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '服务商交仓仓库',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': '服务商交仓仓库'
  },
  {
    序号: 281,
    菜单路由: '/portal/airtms/board-layout-plan/pick-order-reciever',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '提单收件人',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': '提单收件人'
  },
  {
    序号: 282,
    菜单路由: '/portal/airtms/board-layout-plan/box-push-setting',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '箱单推送配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': '箱单推送配置'
  },
  {
    序号: 283,
    菜单路由: '/portal/airtms/board-layout-plan/general-settings',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '通用配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': '通用配置'
  },
  {
    序号: 284,
    菜单路由: '/portal/airtms/board-layout-plan/pick-order-setting',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '提单信息配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': '提单信息配置'
  },
  {
    序号: 285,
    菜单路由: '/portal/airtms/board-layout-plan/server-warehouse-address',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '服务商仓库地址',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': '服务商仓库地址'
  },
  {
    序号: 286,
    菜单路由: '/portal/airtms/board-layout-plan/over-time-manage',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '超时时效管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '基础配置',
    '四级（新）': '超时时效管理'
  },
  {
    序号: 287,
    菜单路由: ' ',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '系统管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '系统管理',
    '四级（新）': ' '
  },
  {
    序号: 288,
    菜单路由: '/portal/airtms/system-manage/data-push-manage',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '系统管理',
    '3级菜单（旧）': '数据推送管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '系统管理',
    '四级（新）': '数据推送管理'
  },
  {
    序号: 289,
    菜单路由: '/portal/airtms/system-manage/mail-send-record',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '系统管理',
    '3级菜单（旧）': '邮件发送记录',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '系统管理',
    '四级（新）': '邮件发送记录'
  },
  {
    序号: 290,
    菜单路由: ' ',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '打印管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '打印管理',
    '四级（新）': ' '
  },
  {
    序号: 291,
    菜单路由: '/portal/airtms/print-manage/air-tag-print',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '打印管理',
    '3级菜单（旧）': '航空标签打印',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '打印管理',
    '四级（新）': '航空标签打印'
  },
  {
    序号: 292,
    菜单路由: '/portal/airtms/download-center',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '任务中心',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '任务中心',
    '四级（新）': ' '
  },
  {
    序号: 293,
    菜单路由: ' ',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '中转管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '中转管理',
    '四级（新）': ' '
  },
  {
    序号: 294,
    菜单路由: '/portal/airtms/transit-manage/air-transit',
    '1级菜单（旧）': '空运管理',
    '2级菜单（旧）': '中转管理',
    '3级菜单（旧）': '国内空运中转',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '中转管理',
    '四级（新）': '国内空运中转'
  },
  {
    序号: 295,
    菜单路由: ' ',
    '1级菜单（旧）': '航空提货',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '进港作业',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 296,
    菜单路由: ' ',
    '1级菜单（旧）': '航空提货',
    '2级菜单（旧）': '进港提货',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '进港作业',
    '三级（新）': '进港提货',
    '四级（新）': ' '
  },
  {
    序号: 297,
    菜单路由: '/portal/ctms/ctms-manage/arrival-pick-up/pick-up-order-manage',
    '1级菜单（旧）': '航空提货',
    '2级菜单（旧）': '进港提货',
    '3级菜单（旧）': '提单管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '进港作业',
    '三级（新）': '进港提货',
    '四级（新）': '提单管理'
  },
  {
    序号: 298,
    菜单路由: '/portal/ctms/ctms-manage/arrival-pick-up/NOA-manage',
    '1级菜单（旧）': '航空提货',
    '2级菜单（旧）': '进港提货',
    '3级菜单（旧）': 'NOA管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '进港作业',
    '三级（新）': '进港提货',
    '四级（新）': 'NOA管理'
  },
  {
    序号: 299,
    菜单路由: '/portal/ctms/ctms-manage/arrival-pick-up/pick-up-task-manage',
    '1级菜单（旧）': '航空提货',
    '2级菜单（旧）': '进港提货',
    '3级菜单（旧）': '进港提货任务管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '进港作业',
    '三级（新）': '进港提货',
    '四级（新）': '进港提货任务管理'
  },
  {
    序号: 300,
    菜单路由: '/portal/ctms/ctms-manage/arrival-pick-up/pick-up-exception-manage',
    '1级菜单（旧）': '航空提货',
    '2级菜单（旧）': '进港提货',
    '3级菜单（旧）': '进港提货异常管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '进港作业',
    '三级（新）': '进港提货',
    '四级（新）': '进港提货异常管理'
  },
  {
    序号: 301,
    菜单路由: '/portal/ctms/ctms-manage/arrival-pick-up/pick-up-backlog-manage',
    '1级菜单（旧）': '航空提货',
    '2级菜单（旧）': '进港提货',
    '3级菜单（旧）': '航空提货待办任务',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '进港作业',
    '三级（新）': '进港提货',
    '四级（新）': '航空提货待办任务'
  },
  {
    序号: 302,
    菜单路由: '/portal/ctms/ctms-manage/arrival-pick-up/sea-pick-up-goods',
    '1级菜单（旧）': '航空提货',
    '2级菜单（旧）': '进港提货',
    '3级菜单（旧）': '海运提货管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '进港作业',
    '三级（新）': '进港提货',
    '四级（新）': '海运提货管理'
  },
  {
    序号: 303,
    菜单路由: ' ',
    '1级菜单（旧）': '空运公告',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 304,
    菜单路由: ' ',
    '1级菜单（旧）': '空运公告',
    '2级菜单（旧）': '公告管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '公告管理',
    '四级（新）': ' '
  },
  {
    序号: 305,
    菜单路由: '/portal/atsweb/AnnouncementManagement',
    '1级菜单（旧）': '空运公告',
    '2级菜单（旧）': '公告管理',
    '3级菜单（旧）': '发布公告',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '空运运输',
    '三级（新）': '公告管理',
    '四级（新）': '发布公告'
  },
  {
    序号: 306,
    菜单路由: ' ',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 307,
    菜单路由: ' ',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '清关订单管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '清关订单管理',
    '四级（新）': ' '
  },
  {
    序号: 308,
    菜单路由: '/portal/cis/rcdispose-record',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '清关订单管理',
    '3级菜单（旧）': '风控处理记录',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '清关订单管理',
    '四级（新）': '风控处理记录'
  },
  {
    序号: 309,
    菜单路由: '/portal/cis/data-notification-rules',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '清关订单管理',
    '3级菜单（旧）': '数据通知规则',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '清关订单管理',
    '四级（新）': '数据通知规则'
  },
  {
    序号: 310,
    菜单路由: '/portal/cis/rule-hitlog',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '清关订单管理',
    '3级菜单（旧）': '规则命中记录',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '清关订单管理',
    '四级（新）': '规则命中记录'
  },
  {
    序号: 311,
    菜单路由: '/portal/cis/name-nocompliant-orders',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '清关订单管理',
    '3级菜单（旧）': '品名不合规订单',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '清关订单管理',
    '四级（新）': '品名不合规订单'
  },
  {
    序号: 312,
    菜单路由: '/portal/cis/receipt-manage',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '清关订单管理',
    '3级菜单（旧）': '清关回执管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '清关订单管理',
    '四级（新）': '清关回执管理'
  },
  {
    序号: 313,
    菜单路由: '/portal/cis/inform-createdata',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '清关订单管理',
    '3级菜单（旧）': '告知函生成管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '清关订单管理',
    '四级（新）': '告知函生成管理'
  },
  {
    序号: 314,
    菜单路由: '/portal/cis/inform-orderdata',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '清关订单管理',
    '3级菜单（旧）': '告知函订单管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '清关订单管理',
    '四级（新）': '告知函订单管理'
  },
  {
    序号: 315,
    菜单路由: ' ',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '出口报关资料管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '出口报关资料管理',
    '四级（新）': ' '
  },
  {
    序号: 316,
    菜单路由: '/portal/cis/customs-data-check',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '出口报关资料管理',
    '3级菜单（旧）': '报关资料检查',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '出口报关资料管理',
    '四级（新）': '报关资料检查'
  },
  {
    序号: 317,
    菜单路由: '/portal/cis/freight-customs-management',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '出口报关资料管理',
    '3级菜单（旧）': '空运单独报关管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '出口报关资料管理',
    '四级（新）': '空运单独报关管理'
  },
  {
    序号: 318,
    菜单路由: ' ',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '进口清关资料管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '进口清关资料管理',
    '四级（新）': ' '
  },
  {
    序号: 319,
    菜单路由: '/portal/cis/data-check',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '进口清关资料管理',
    '3级菜单（旧）': '清关资料检查',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '进口清关资料管理',
    '四级（新）': '清关资料检查'
  },
  {
    序号: 320,
    菜单路由: '/portal/cis/email-sent',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '进口清关资料管理',
    '3级菜单（旧）': '邮件发送记录',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '进口清关资料管理',
    '四级（新）': '邮件发送记录'
  },
  {
    序号: 321,
    菜单路由: '/portal/cis/bill-push-record',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '进口清关资料管理',
    '3级菜单（旧）': '提单推送记录',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '进口清关资料管理',
    '四级（新）': '提单推送记录'
  },
  {
    序号: 322,
    菜单路由: '/portal/cis/timeliness-monitoring',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '进口清关资料管理',
    '3级菜单（旧）': '资料时效监控列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '进口清关资料管理',
    '四级（新）': '资料时效监控列表'
  },
  {
    序号: 323,
    菜单路由: ' ',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': ' '
  },
  {
    序号: 324,
    菜单路由: '/portal/cis/clearance-area-configuration',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': '清关区域配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': '清关区域配置'
  },
  {
    序号: 325,
    菜单路由: '/portal/cis/clearance-port-configuration',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': '清关口岸配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': '清关口岸配置'
  },
  {
    序号: 326,
    菜单路由: '/portal/cis/rules-list',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': '规则库列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': '规则库列表'
  },
  {
    序号: 327,
    菜单路由: '/portal/cis/rule-management',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': '规则类型管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': '规则类型管理'
  },
  {
    序号: 328,
    菜单路由: '/portal/cis/clearance-recipient',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': '清关收件人管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': '清关收件人管理'
  },
  {
    序号: 329,
    菜单路由: '/portal/cis/resource-list',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': '清关资源列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': '清关资源列表'
  },
  {
    序号: 330,
    菜单路由: '/portal/cis/serve-group',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': '清关服务与工序',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': '清关服务与工序'
  },
  {
    序号: 331,
    菜单路由: '/portal/cis/product-service-group',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': '产品服务组合',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': '产品服务组合'
  },
  {
    序号: 332,
    菜单路由: '/portal/cis/clearance-billing-configuration',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': '清关计费方式配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': '清关计费方式配置'
  },
  {
    序号: 333,
    菜单路由: '/portal/cis/apollo-configuration',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': '阿波罗配置列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': '阿波罗配置列表'
  },
  {
    序号: 334,
    菜单路由: '/portal/cis/ocr-configuration',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': 'OCR识别规则配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': 'OCR识别规则配置'
  },
  {
    序号: 335,
    菜单路由: '/portal/cis/exception-configuration',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '关务规则配置',
    '3级菜单（旧）': '异常类型配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '关务规则配置',
    '四级（新）': '异常类型配置'
  },
  {
    序号: 336,
    菜单路由: ' ',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '税单管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '税单管理',
    '四级（新）': ' '
  },
  {
    序号: 337,
    菜单路由: '/portal/cis/tax-manage',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '税单管理',
    '3级菜单（旧）': '税单监控列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '税单管理',
    '四级（新）': '税单监控列表'
  },
  {
    序号: 338,
    菜单路由: '/portal/cis/tax-bill-analysis',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '税单管理',
    '3级菜单（旧）': '税单附件解析',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '税单管理',
    '四级（新）': '税单附件解析'
  },
  {
    序号: 339,
    菜单路由: ' ',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': ' '
  },
  {
    序号: 340,
    菜单路由: '/portal/cis/product-compliance-library',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '品名合规库',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '品名合规库'
  },
  {
    序号: 341,
    菜单路由: '/portal/cis/coding-class',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '品类海关编码库',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '品类海关编码库'
  },
  {
    序号: 342,
    菜单路由: '/portal/cis/customs-code-blacklist',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '海关编码黑名单',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '海关编码黑名单'
  },
  {
    序号: 343,
    菜单路由: '/portal/cis/sku-library',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '专线-SKU库',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '专线-SKU库'
  },
  {
    序号: 344,
    菜单路由: '/portal/cis/public-sender-management',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '发件人信息管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '发件人信息管理'
  },
  {
    序号: 345,
    菜单路由: '/portal/cis/basic-library',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '数据引用基础库',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '数据引用基础库'
  },
  {
    序号: 346,
    菜单路由: '/portal/cis/regional-sensitive-words',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '区域敏感词管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '区域敏感词管理'
  },
  {
    序号: 347,
    菜单路由: '/portal/cis/map-database',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '映射数据库',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '映射数据库'
  },
  {
    序号: 348,
    菜单路由: '/portal/cis/address-library',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '海外地址引用库',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '海外地址引用库'
  },
  {
    序号: 349,
    菜单路由: '/portal/cis/minor-languages',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '小语种',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '小语种'
  },
  {
    序号: 350,
    菜单路由: '/portal/cis/exchange-rate-management',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '清关汇率列表',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '清关汇率列表'
  },
  {
    序号: 351,
    菜单路由: '/portal/cis/end-service-configuration',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '末端服务商配置',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '末端服务商配置'
  },
  {
    序号: 352,
    菜单路由: '/portal/cis/postal-code-library',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '海外邮编引用库',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '海外邮编引用库'
  },
  {
    序号: 353,
    菜单路由: '/portal/cis/declare-exchange-rate',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '关务申报汇率',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '关务申报汇率'
  },
  {
    序号: 354,
    菜单路由: ' ',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '日志管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '日志管理',
    '四级（新）': ' '
  },
  {
    序号: 355,
    菜单路由: '/portal/cis/download-center',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '日志管理',
    '3级菜单（旧）': '清关系统下载中心',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '日志管理',
    '四级（新）': '清关系统下载中心'
  },
  {
    序号: 356,
    菜单路由: '/portal/cis/push-records',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '日志管理',
    '3级菜单（旧）': '推送记录',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '日志管理',
    '四级（新）': '推送记录'
  },
  {
    序号: 357,
    菜单路由: ' ',
    '1级菜单（旧）': '服务商门户',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '服务商门户',
    '三级（新）': '服务商信息',
    '四级（新）': ' '
  },
  {
    序号: 358,
    菜单路由: '/portal/spp/node-back-rules',
    '1级菜单（旧）': '服务商门户',
    '2级菜单（旧）': '节点回传时效提醒规则',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '服务商门户',
    '三级（新）': '服务商信息',
    '四级（新）': '节点回传时效提醒'
  },
  {
    序号: 359,
    菜单路由: '/portal/spp/node-back-standard',
    '1级菜单（旧）': '服务商门户',
    '2级菜单（旧）': '节点回传时效标准',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '服务商门户',
    '三级（新）': '服务商信息',
    '四级（新）': '节点回传时效标准'
  },
  {
    序号: 360,
    菜单路由: '/portal/spp/node-verify-rules',
    '1级菜单（旧）': '服务商门户',
    '2级菜单（旧）': '节点校验规则',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '服务商门户',
    '三级（新）': '服务商信息',
    '四级（新）': '节点校验规则'
  },
  {
    序号: 361,
    菜单路由: '/portal/spp/operate-node-monitoring',
    '1级菜单（旧）': '服务商门户',
    '2级菜单（旧）': '操作节点监控与管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '服务商门户',
    '三级（新）': '服务商信息',
    '四级（新）': '操作节点监控管理'
  },
  {
    序号: 362,
    菜单路由: '/portal/spp/operate-node-maintain',
    '1级菜单（旧）': '服务商门户',
    '2级菜单（旧）': '操作节点维护',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '服务商门户',
    '三级（新）': '服务商信息',
    '四级（新）': '操作节点维护'
  },
  {
    序号: 363,
    菜单路由: '/portal/spp/import-download',
    '1级菜单（旧）': '服务商门户',
    '2级菜单（旧）': '导入与下载中心',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '服务商门户',
    '三级（新）': '服务商信息',
    '四级（新）': '导入与下载中心'
  },
  {
    序号: 364,
    菜单路由: '/portal/spp/log-manage',
    '1级菜单（旧）': '服务商门户',
    '2级菜单（旧）': '日志管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '服务商门户',
    '三级（新）': '服务商信息',
    '四级（新）': '日志管理'
  },
  {
    序号: 656,
    菜单路由: ' ',
    '1级菜单（旧）': '海运管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '海运运输',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 657,
    菜单路由: ' ',
    '1级菜单（旧）': '海运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '海运运输',
    '三级（新）': '基础数据',
    '四级（新）': ' '
  },
  {
    序号: 658,
    菜单路由: '/portal/sea-tms/sea-base-data/container-specifications',
    '1级菜单（旧）': '海运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '集装箱规格',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '海运运输',
    '三级（新）': '基础数据',
    '四级（新）': '集装箱规格'
  },
  {
    序号: 659,
    菜单路由: '/portal/sea-tms/sea-base-data/sea-bill-consignor',
    '1级菜单（旧）': '海运管理',
    '2级菜单（旧）': '基础数据',
    '3级菜单（旧）': '提单发货人',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '海运运输',
    '三级（新）': '基础数据',
    '四级（新）': '提单发货人'
  },
  {
    序号: 660,
    菜单路由: '/portal/sea-tms/resource-manage',
    '1级菜单（旧）': '海运管理',
    '2级菜单（旧）': '资源管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '海运运输',
    '三级（新）': '资源管理',
    '四级（新）': ' '
  },
  {
    序号: 661,
    菜单路由: '/portal/sea-tms/sea-cabinet-apply-plan',
    '1级菜单（旧）': '海运管理',
    '2级菜单（旧）': '排柜计划',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '海运运输',
    '三级（新）': '排柜计划',
    '四级（新）': ' '
  },
  {
    序号: 662,
    菜单路由: '/portal/sea-tms/sea-match-goods',
    '1级菜单（旧）': '海运管理',
    '2级菜单（旧）': '配货管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '海运运输',
    '三级（新）': '配货管理',
    '四级（新）': ' '
  },
  {
    序号: 663,
    菜单路由: '/portal/sea-tms/sea-pick-order',
    '1级菜单（旧）': '海运管理',
    '2级菜单（旧）': '提单管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '海运运输',
    '三级（新）': '提单管理',
    '四级（新）': ' '
  },
  {
    序号: 2105,
    菜单路由: ' ',
    '1级菜单（旧）': '揽收管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '揽收作业',
    '三级（新）': '揽收管理',
    '四级（新）': ' '
  },
  {
    序号: 2106,
    菜单路由: '/portal/prs/yun-express-draw',
    '1级菜单（旧）': '揽收管理',
    '2级菜单（旧）': '云图绘',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '揽收作业',
    '三级（新）': '揽收管理',
    '四级（新）': '云图绘'
  },
  {
    序号: 2107,
    菜单路由: '/portal/tms/download-center',
    '1级菜单（旧）': '陆运管理',
    '2级菜单（旧）': '任务中心',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '陆运运输',
    '三级（新）': '任务中心',
    '四级（新）': ' '
  },
  {
    序号: 2108,
    菜单路由: '/portal/cis/abnormal-management',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '清关订单管理',
    '3级菜单（旧）': '异常数据管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '清关订单管理',
    '四级（新）': '异常数据管理'
  },
  {
    序号: 2109,
    菜单路由: '/portal/cis/protocol-management',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '出口报关资料管理',
    '3级菜单（旧）': '出口授权协议管理',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '出口报关资料管理',
    '四级（新）': '出口授权协议管理'
  },
  {
    序号: 2110,
    菜单路由: '/portal/cis/template-conversion-records',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '进口清关资料管理',
    '3级菜单（旧）': '模版转换记录',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '进口清关资料管理',
    '四级（新）': '模版转换记录'
  },
  {
    序号: 2111,
    菜单路由: '/portal/cis/template-conversion-results',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '进口清关资料管理',
    '3级菜单（旧）': '转换资料检查',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '进口清关资料管理',
    '四级（新）': '转换资料检查'
  },
  {
    序号: 2112,
    菜单路由: '/portal/cis/customs-code-rate',
    '1级菜单（旧）': '关务管理',
    '2级菜单（旧）': '基础数据库',
    '3级菜单（旧）': '全球海关编码及税率库',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '关务服务',
    '三级（新）': '基础数据库',
    '四级（新）': '全球海关编码及税率库'
  },
  {
    序号: 2156,
    菜单路由: '/portal/sea-tms/full-container-order',
    '1级菜单（旧）': '海运管理',
    '2级菜单（旧）': '整柜订单',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '履约交付',
    '二级（新）': '海运运输',
    '三级（新）': '整柜订单',
    '四级（新）': ' '
  },
  {
    序号: 593,
    菜单路由: ' ',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 594,
    菜单路由: '/portal/basicdata/public-manage',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '基础数据列表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '基础数据列表',
    '四级（新）': ' '
  },
  {
    序号: 595,
    菜单路由: '/portal/basicdata/word-manage',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '词条管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '词条管理',
    '四级（新）': ' '
  },
  {
    序号: 596,
    菜单路由: '/portal/basicdata/word-statistics',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '词条统计',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '词条统计',
    '四级（新）': ' '
  },
  {
    序号: 597,
    菜单路由: '/portal/basicdata/table-meta-data',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '表元数据',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '表元数据',
    '四级（新）': ' '
  },
  {
    序号: 598,
    菜单路由: '/portal/basicdata/key-manage',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '秘钥管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '秘钥管理',
    '四级（新）': ' '
  },
  {
    序号: 599,
    菜单路由: '/portal/basicdata/fees-payable',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '应收费用项',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '应收费用项',
    '四级（新）': ' '
  },
  {
    序号: 600,
    菜单路由: '/portal/basicdata/cost-type',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '费用项',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '费用项',
    '四级（新）': ' '
  },
  {
    序号: 601,
    菜单路由: '/portal/basicdata/cost-group',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '费用项分组',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '费用项分组',
    '四级（新）': ' '
  },
  {
    序号: 602,
    菜单路由: '/portal/basicdata/service-type',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '额外服务类型',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '额外服务类型',
    '四级（新）': ' '
  },
  {
    序号: 603,
    菜单路由: '/portal/basicdata/service-group',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '额外服务分组',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '额外服务分组',
    '四级（新）': ' '
  },
  {
    序号: 604,
    菜单路由: '/portal/basicdata/basic-pages/pt_currencytype',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '币种',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '币种',
    '四级（新）': ' '
  },
  {
    序号: 605,
    菜单路由: '/portal/basicdata/basic-pages/pt_country',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '国家',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '国家',
    '四级（新）': ' '
  },
  {
    序号: 606,
    菜单路由: '/portal/basicdata/basic-pages/pt_port',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '港口',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '港口',
    '四级（新）': ' '
  },
  {
    序号: 607,
    菜单路由: '/portal/basicdata/basic-pages/sys_clearance_port_info',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '清关口岸',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '清关口岸',
    '四级（新）': ' '
  },
  {
    序号: 608,
    菜单路由: '/portal/basicdata/basic-pages/pt_transport',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '转运点维护',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '转运点维护',
    '四级（新）': ' '
  },
  {
    序号: 609,
    菜单路由: '/portal/basicdata/basic-pages/pt_ship_company',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '船公司',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '船公司',
    '四级（新）': ' '
  },
  {
    序号: 610,
    菜单路由: '/portal/basicdata/basic-pages/sys_airline_company',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '航空公司',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '航空公司',
    '四级（新）': ' '
  },
  {
    序号: 611,
    菜单路由: '/portal/basicdata/basic-pages/sys_airport_info',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '机场',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '机场',
    '四级（新）': ' '
  },
  {
    序号: 612,
    菜单路由: '/portal/basicdata/basic-pages/enumeration',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '枚举',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '枚举',
    '四级（新）': ' '
  },
  {
    序号: 613,
    菜单路由: '/portal/basicdata/basic-pages/sys_language_info',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '多语言信息',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '多语言信息',
    '四级（新）': ' '
  },
  {
    序号: 614,
    菜单路由: '/portal/basicdata/basic-pages/signservice',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '签约服务商',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '签约服务商',
    '四级（新）': ' '
  },
  {
    序号: 615,
    菜单路由: '/portal/basicdata/basic-pages/csi_customer_body',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '签约主体',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '签约主体',
    '四级（新）': ' '
  },
  {
    序号: 616,
    菜单路由: '/portal/basicdata/basic-pages/csi_productkind',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '销售产品（国内）',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '销售产品（国内）',
    '四级（新）': ' '
  },
  {
    序号: 617,
    菜单路由: '/portal/basicdata/basic-pages/csi_productkindeu',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '销售产品（欧洲）',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '销售产品（欧洲）',
    '四级（新）': ' '
  },
  {
    序号: 618,
    菜单路由: '/portal/basicdata/basic-pages/csi_productkindus',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '销售产品（美国）',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '销售产品（美国）',
    '四级（新）': ' '
  },
  {
    序号: 619,
    菜单路由: '/portal/basicdata/basic-pages/csi_server',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '服务商',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '服务商',
    '四级（新）': ' '
  },
  {
    序号: 620,
    菜单路由: '/portal/basicdata/basic-pages/csi_servechannel',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '服务商渠道',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '服务商渠道',
    '四级（新）': ' '
  },
  {
    序号: 621,
    菜单路由: '/portal/basicdata/basic-pages/valueaddedservices',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '额外服务',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '额外服务',
    '四级（新）': ' '
  },
  {
    序号: 622,
    菜单路由: '/portal/basicdata/basic-pages/jobnode',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '作业节点',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '作业节点',
    '四级（新）': ' '
  },
  {
    序号: 623,
    菜单路由: '/portal/basicdata/basic-pages/jobnodetype',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '作业类型',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '作业类型',
    '四级（新）': ' '
  },
  {
    序号: 624,
    菜单路由: '/portal/basicdata/basic-pages/operatingoutlets',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '操作网点',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '操作网点',
    '四级（新）': ' '
  },
  {
    序号: 625,
    菜单路由: '/portal/basicdata/basic-pages/product_group',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '销售产品组',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '销售产品组',
    '四级（新）': ' '
  },
  {
    序号: 626,
    菜单路由: '/portal/basicdata/basic-pages/sys_server_config',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '获取服务列表配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '获取服务列表配置',
    '四级（新）': ' '
  },
  {
    序号: 627,
    菜单路由: '/portal/basicdata/basic-pages/customs',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '关区管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '关区管理',
    '四级（新）': ' '
  },
  {
    序号: 628,
    菜单路由: '/portal/basicdata/basic-pages/csi_endserver',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '末端服务商',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '末端服务商',
    '四级（新）': ' '
  },
  {
    序号: 629,
    菜单路由: '/portal/basicdata/basic-pages/airportcargoterminal',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '机场货站',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '机场货站',
    '四级（新）': ' '
  },
  {
    序号: 630,
    菜单路由: '/portal/basicdata/basic-pages/channel_ep',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '装箱渠道（国内）',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '装箱渠道（国内）',
    '四级（新）': ' '
  },
  {
    序号: 631,
    菜单路由: '/portal/basicdata/basic-pages/channel_ep_eu',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '装箱渠道（欧洲）',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '装箱渠道（欧洲）',
    '四级（新）': ' '
  },
  {
    序号: 632,
    菜单路由: '/portal/basicdata/basic-pages/channel_ep_us',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '装箱渠道（美国）',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '装箱渠道（美国）',
    '四级（新）': ' '
  },
  {
    序号: 633,
    菜单路由: '/portal/basicdata/basic-pages/performance',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '履约',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '履约',
    '四级（新）': ' '
  },
  {
    序号: 634,
    菜单路由: '/portal/basicdata/basic-pages/enumeration_data',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '枚举数据',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '枚举数据',
    '四级（新）': ' '
  },
  {
    序号: 635,
    菜单路由: '/portal/basicdata/basic-pages/holiday',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '节假日管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '节假日管理',
    '四级（新）': ' '
  },
  {
    序号: 636,
    菜单路由: '/portal/basicdata/basic-pages/rate_maintenance_info',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '单位进率维护管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '单位进率维护管理',
    '四级（新）': ' '
  },
  {
    序号: 637,
    菜单路由: '/portal/basicdata/basic-pages/claimsettlement',
    '1级菜单（旧）': '基础数据',
    '2级菜单（旧）': '理赔',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '基础数据',
    '三级（新）': '理赔',
    '四级（新）': ' '
  },
  {
    序号: 638,
    菜单路由: '/portal/center/async-export',
    '1级菜单（旧）': '下载中心',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '下载中心',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 650,
    菜单路由: ' ',
    '1级菜单（旧）': '服务商对接配置',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '服务商对接配置',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 651,
    菜单路由: '/portal/spc/interface-process',
    '1级菜单（旧）': '服务商对接配置',
    '2级菜单（旧）': '业务接口流程',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '服务商对接配置',
    '三级（新）': '业务接口流程',
    '四级（新）': ' '
  },
  {
    序号: 652,
    菜单路由: '/portal/spc/map-templates',
    '1级菜单（旧）': '服务商对接配置',
    '2级菜单（旧）': '映射模板',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '服务商对接配置',
    '三级（新）': '映射模板',
    '四级（新）': ' '
  },
  {
    序号: 653,
    菜单路由: '/portal/spc/forecast-record',
    '1级菜单（旧）': '服务商对接配置',
    '2级菜单（旧）': '预报记录查询',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '服务商对接配置',
    '三级（新）': '预报记录查询',
    '四级（新）': ' '
  },
  {
    序号: 654,
    菜单路由: '/portal/spc/function-library',
    '1级菜单（旧）': '服务商对接配置',
    '2级菜单（旧）': '函数库',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '服务商对接配置',
    '三级（新）': '函数库',
    '四级（新）': ' '
  },
  {
    序号: 655,
    菜单路由: '/portal/spc/variable-library',
    '1级菜单（旧）': '服务商对接配置',
    '2级菜单（旧）': '变量库',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '服务商对接配置',
    '三级（新）': '变量库',
    '四级（新）': ' '
  },
  {
    序号: 2113,
    菜单路由: ' ',
    '1级菜单（旧）': '服务商账号',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '服务商账号',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2114,
    菜单路由: '/portal/ctms/service-provider-manage/account-manage',
    '1级菜单（旧）': '服务商账号',
    '2级菜单（旧）': '账号管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '服务商账号',
    '三级（新）': '账号管理',
    '四级（新）': ' '
  },
  {
    序号: 2115,
    菜单路由: '/portal/ctms/service-provider-manage/login-log',
    '1级菜单（旧）': '服务商账号',
    '2级菜单（旧）': '登录日志',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '系统配置',
    '二级（新）': '服务商账号',
    '三级（新）': '登录日志',
    '四级（新）': ' '
  },
  {
    序号: 639,
    菜单路由: '/portal/server/server-manage/server-list',
    '1级菜单（旧）': '服务器管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '服务器管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 640,
    菜单路由: ' ',
    '1级菜单（旧）': '日志监控',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '日志监控',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 641,
    菜单路由: '/portal/server/log-monitor/audit-log',
    '1级菜单（旧）': '日志监控',
    '2级菜单（旧）': '审计日志',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '日志监控',
    '三级（新）': '审计日志',
    '四级（新）': ' '
  },
  {
    序号: 642,
    菜单路由: '/portal/server/log-monitor/business-log',
    '1级菜单（旧）': '日志监控',
    '2级菜单（旧）': '业务日志',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '日志监控',
    '三级（新）': '业务日志',
    '四级（新）': ' '
  },
  {
    序号: 643,
    菜单路由: ' ',
    '1级菜单（旧）': '消息投递',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '消息投递',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 644,
    菜单路由: '/portal/middleware/message-delivery/topic',
    '1级菜单（旧）': '消息投递',
    '2级菜单（旧）': '消息主体',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '消息投递',
    '三级（新）': '消息主体',
    '四级（新）': ' '
  },
  {
    序号: 645,
    菜单路由: '/portal/middleware/message-delivery/subscribe',
    '1级菜单（旧）': '消息投递',
    '2级菜单（旧）': '消息服务监控',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '消息投递',
    '三级（新）': '消息服务监控',
    '四级（新）': ' '
  },
  {
    序号: 646,
    菜单路由: '/portal/middleware/message-delivery/terminal',
    '1级菜单（旧）': '消息投递',
    '2级菜单（旧）': '终端管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '消息投递',
    '三级（新）': '终端管理',
    '四级（新）': ' '
  },
  {
    序号: 647,
    菜单路由: '/portal/middleware/message-delivery/dataCenterLoge',
    '1级菜单（旧）': '消息投递',
    '2级菜单（旧）': '数据中心日志',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '消息投递',
    '三级（新）': '数据中心日志',
    '四级（新）': ' '
  },
  {
    序号: 648,
    菜单路由: '/portal/middleware/message-delivery/log',
    '1级菜单（旧）': '消息投递',
    '2级菜单（旧）': '消息主题详情-日志',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '消息投递',
    '三级（新）': '消息主题详情-日志',
    '四级（新）': ' '
  },
  {
    序号: 649,
    菜单路由: '/portal/cron/planing-list',
    '1级菜单（旧）': '计划任务',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '计划任务',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2120,
    菜单路由: ' ',
    '1级菜单（旧）': '多语言翻译',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '多语言翻译',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2121,
    菜单路由: '/portal/tsn/system',
    '1级菜单（旧）': '多语言翻译',
    '2级菜单（旧）': '词条系统管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '多语言翻译',
    '三级（新）': '词条系统管理',
    '四级（新）': ' '
  },
  {
    序号: 2122,
    菜单路由: '/portal/tsn/translation',
    '1级菜单（旧）': '多语言翻译',
    '2级菜单（旧）': '词条翻译列表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '多语言翻译',
    '三级（新）': '词条翻译列表',
    '四级（新）': ' '
  },
  {
    序号: 2123,
    菜单路由: ' ',
    '1级菜单（旧）': '多语言翻译',
    '2级菜单（旧）': '基础数据管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '多语言翻译',
    '三级（新）': '基础数据管理',
    '四级（新）': ' '
  },
  {
    序号: 2124,
    菜单路由: '/portal/tsn/log',
    '1级菜单（旧）': '多语言翻译',
    '2级菜单（旧）': '基础数据管理',
    '3级菜单（旧）': '词条维护日志',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '多语言翻译',
    '三级（新）': '基础数据管理',
    '四级（新）': '词条维护日志'
  },
  {
    序号: 2125,
    菜单路由: '/portal/tsn/wordstatistics',
    '1级菜单（旧）': '多语言翻译',
    '2级菜单（旧）': '基础数据管理',
    '3级菜单（旧）': '翻译语言统计',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '多语言翻译',
    '三级（新）': '基础数据管理',
    '四级（新）': '翻译语言统计'
  },
  {
    序号: 2126,
    菜单路由: ' ',
    '1级菜单（旧）': 'Deploy3',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': 'Deploy3',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2127,
    菜单路由: '/portal/deploy/app-manage/deployment',
    '1级菜单（旧）': 'Deploy3',
    '2级菜单（旧）': '部署管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': 'Deploy3',
    '三级（新）': '部署管理',
    '四级（新）': ' '
  },
  {
    序号: 2128,
    菜单路由: '/portal/deploy/operation/deployment-status',
    '1级菜单（旧）': 'Deploy3',
    '2级菜单（旧）': '部署状态',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': 'Deploy3',
    '三级（新）': '部署状态',
    '四级（新）': ' '
  },
  {
    序号: 2129,
    菜单路由: '/portal/deploy/operation/relationship',
    '1级菜单（旧）': 'Deploy3',
    '2级菜单（旧）': '关系管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': 'Deploy3',
    '三级（新）': '关系管理',
    '四级（新）': ' '
  },
  {
    序号: 2130,
    菜单路由: '/portal/deploy/report/deploy-statistics',
    '1级菜单（旧）': 'Deploy3',
    '2级菜单（旧）': '部署统计',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': 'Deploy3',
    '三级（新）': '部署统计',
    '四级（新）': ' '
  },
  {
    序号: 2131,
    菜单路由: '/portal/deploy/report/deploy-statistics/real-time',
    '1级菜单（旧）': 'Deploy3',
    '2级菜单（旧）': '部署实时统计',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': 'Deploy3',
    '三级（新）': '部署实时统计',
    '四级（新）': ' '
  },
  {
    序号: 2132,
    菜单路由: ' ',
    '1级菜单（旧）': '资源组管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '资源组管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2133,
    菜单路由: '/portal/resource/resource-management/middleground',
    '1级菜单（旧）': '资源组管理',
    '2级菜单（旧）': '研发中心',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '资源组管理',
    '三级（新）': '研发中心',
    '四级（新）': ' '
  },
  {
    序号: 2134,
    菜单路由: '/portal/deploy/app-manage/application',
    '1级菜单（旧）': '资源组管理',
    '2级菜单（旧）': '应用管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '资源组管理',
    '三级（新）': '应用管理',
    '四级（新）': ' '
  },
  {
    序号: 2135,
    菜单路由: '/portal/resource/resource-management/apply-list',
    '1级菜单（旧）': '资源组管理',
    '2级菜单（旧）': '资源申请列表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '资源组管理',
    '三级（新）': '资源申请列表',
    '四级（新）': ' '
  },
  {
    序号: 2136,
    菜单路由: '/portal/resource/resource-management/cluster',
    '1级菜单（旧）': '资源组管理',
    '2级菜单（旧）': '集群管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '资源组管理',
    '三级（新）': '集群管理',
    '四级（新）': ' '
  },
  {
    序号: 2137,
    菜单路由: '/portal/resource/resource-management/load-balancer',
    '1级菜单（旧）': '资源组管理',
    '2级菜单（旧）': '负载均衡器',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '资源组管理',
    '三级（新）': '负载均衡器',
    '四级（新）': ' '
  },
  {
    序号: 2138,
    菜单路由: '/portal/resource/resource-management/entrypoint',
    '1级菜单（旧）': '资源组管理',
    '2级菜单（旧）': '接入点管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '资源组管理',
    '三级（新）': '接入点管理',
    '四级（新）': ' '
  },
  {
    序号: 2139,
    菜单路由: '/portal/resource/resource-management/middleware-type',
    '1级菜单（旧）': '资源组管理',
    '2级菜单（旧）': '中间件类型管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '资源组管理',
    '三级（新）': '中间件类型管理',
    '四级（新）': ' '
  },
  {
    序号: 2140,
    菜单路由: '/portal/resource/resource-management/hardware-specification',
    '1级菜单（旧）': '资源组管理',
    '2级菜单（旧）': '硬件配置管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '资源组管理',
    '三级（新）': '硬件配置管理',
    '四级（新）': ' '
  },
  {
    序号: 2141,
    菜单路由: '/portal/resource/resource-management/workbench',
    '1级菜单（旧）': '资源组管理',
    '2级菜单（旧）': '系统管理',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '资源组管理',
    '三级（新）': '系统管理',
    '四级（新）': ' '
  },
  {
    序号: 2142,
    菜单路由: '/portal/resource/resource-management/cost-board',
    '1级菜单（旧）': '资源组管理',
    '2级菜单（旧）': '资源成本看板',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '资源组管理',
    '三级（新）': '资源成本看板',
    '四级（新）': ' '
  },
  {
    序号: 2143,
    菜单路由: ' ',
    '1级菜单（旧）': '数据分发',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '数据分发',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2144,
    菜单路由: '/portal/middleware/data-distribution/dataSourceList',
    '1级菜单（旧）': '数据分发',
    '2级菜单（旧）': '订阅列表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '数据分发',
    '三级（新）': '订阅列表',
    '四级（新）': ' '
  },
  {
    序号: 2145,
    菜单路由: '/portal/deploy/frontend-deploy',
    '1级菜单（旧）': '包管理网站',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '包管理网站',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2146,
    菜单路由: '/portal/middleware/api-route',
    '1级菜单（旧）': 'API路由管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': 'API路由管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2147,
    菜单路由: ' ',
    '1级菜单（旧）': '客户端管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '客户端管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2148,
    菜单路由: '/portal/client/client-management/key',
    '1级菜单（旧）': '客户端管理',
    '2级菜单（旧）': '激活码列表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '客户端管理',
    '三级（新）': '激活码列表',
    '四级（新）': ' '
  },
  {
    序号: 2149,
    菜单路由: '/portal/client/client-management/instance',
    '1级菜单（旧）': '客户端管理',
    '2级菜单（旧）': '实例列表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '客户端管理',
    '三级（新）': '实例列表',
    '四级（新）': ' '
  },
  {
    序号: 2150,
    菜单路由: '/portal/client/client-management/aisle',
    '1级菜单（旧）': '客户端管理',
    '2级菜单（旧）': '通道列表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '客户端管理',
    '三级（新）': '通道列表',
    '四级（新）': ' '
  },
  {
    序号: 2151,
    菜单路由: '/portal/client/client-management/apply',
    '1级菜单（旧）': '客户端管理',
    '2级菜单（旧）': '申请列表',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '客户端管理',
    '三级（新）': '申请列表',
    '四级（新）': ' '
  },
  {
    序号: 2152,
    菜单路由: '/portal/client/client-management/server',
    '1级菜单（旧）': '客户端管理',
    '2级菜单（旧）': '服务端配置',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': '客户端管理',
    '三级（新）': '服务端配置',
    '四级（新）': ' '
  },
  {
    序号: 2153,
    菜单路由: ' ',
    '1级菜单（旧）': 'BS用户管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': 'BS用户管理',
    '三级（新）': ' ',
    '四级（新）': ' '
  },
  {
    序号: 2154,
    菜单路由: '/portal/permission/accounts/operation-log-employee',
    '1级菜单（旧）': 'BS用户管理',
    '2级菜单（旧）': '操作日志-用户',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': 'BS用户管理',
    '三级（新）': '操作日志-用户',
    '四级（新）': ' '
  },
  {
    序号: 2155,
    菜单路由: '/portal/permission/accounts/user-login-log',
    '1级菜单（旧）': 'BS用户管理',
    '2级菜单（旧）': '用户登录日志',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': '技术配置',
    '二级（新）': 'BS用户管理',
    '三级（新）': '用户登录日志',
    '四级（新）': ' '
  },
  {
    序号: 365,
    菜单路由: ' ',
    '1级菜单（旧）': '服务商管理',
    '2级菜单（旧）': ' ',
    '3级菜单（旧）': ' ',
    '4级菜单（旧）': ' ',
    '一级（新）': ' ',
    '二级（新）': ' ',
    '三级（新）': ' ',
    '四级（新）': ' '
  }
]

/**
 * 20251215 菜单变更提示标识
 */
export const NEW_MENU_FLAG = 'newMenuFlag'

/**
 * 收藏菜单缓存key
 */
export const collectMenuKey = 'collectMenu'

/**
 * 退出不需要清除的storage key
 */

export const SAVE_STORAGE_LIST = [collectMenuKey, NEW_MENU_FLAG]
